import {
  Button,
  Checkbox,
  createStyles,
  DialogActions,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import InfoIcon from '@material-ui/icons/Info';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import copy from 'copy-to-clipboard';
import CSS from 'csstype';
import { cloneDeep, set } from 'lodash-es';
import moment from 'moment';
import React, { ChangeEvent, JSX } from 'react';
import update from 'react-addons-update';
import { v4 as uuid } from 'uuid';

import {
  convertStringToPublisherType,
  createSAMLIdentityProvider,
  DEFAULT_PUBLICA_VAULT_CONFIG,
  deleteSAMLIdentityProvider,
  FreeTrialStatusDisabled,
  FreeTrialStatusEnabled,
  getLocalizations,
  getResellers,
  getSAMLIdentityProvider,
  ILocalization,
  IPublicaVaultConfig,
  IPublisher,
  IReseller,
  ISAMLIdentityProvider,
  MRMEnrichmentMode,
  queryPublishers,
  ResourceActiveEnabled,
  updatePublisher,
  updatePublishersActive,
  updateSAMLIdentityProvider,
  updateSAMLIdentityProviderEnabledOnly,
} from '~/src/dash/api/console-api';
import {
  createDealDemandPartner,
  deleteDealDemandPartner,
  getDealDemandPartners,
} from '~/src/dash/api/deal-demand-partner/deal-demand-partner-methods';
import { IDealDemandPartner } from '~/src/dash/api/deal-demand-partner/deal-demand-partner-models';
import {
  convertECurrencyTypeToString,
  convertECurrencyTypeToSymbol,
  convertStringToECurrencyType,
  CurrencyDisplayedItem,
} from '~/src/dash/api/exchange-rates';
import { IRole } from '~/src/dash/api/permissions/model';
import { IObject } from '~/src/dash/api/resource-transforms';
import { createUrl, IHttpResponse, restGet } from '~/src/dash/api/rest';
import {
  createOrUpdateS3AccessPoint,
  getS3AccessPoint,
  IS3AccessPoint,
} from '~/src/dash/api/s3-access-points';
import { EBool } from '~/src/dash/api/types/bool';
import { IBoolDictionary } from '~/src/dash/api/types/map';
import {
  getPublisherAPIToken,
  getPublisherThirdPartyAPITokens,
  IThirdPartyAPIToken,
  updatePublisherAPIToken,
} from '~/src/dash/apiV2/publisher/apiToken';
import { getExcludedReportingDimensionItems } from '~/src/dash/apiV2/reporting/reportTypes';
import { AsyncButtonOldV2, CopyButton } from '~/src/dash/components/button';
import {
  DateTimeRangeComponent,
  IDateRangeChangeEvent,
} from '~/src/dash/components/datepicker/date-time-range-component';
import {
  FormItemTypeModelSelect,
  FormItemTypeMultiSelect,
  FormItemTypePassword,
  FormItemTypeSingleSelect,
  FormItemTypeText,
  IFormData,
  IFormItem,
  RenderForm,
} from '~/src/dash/components/form';
import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { IModel, IModelBase } from '~/src/dash/components/model';
import { createDialogWithCustomStyles } from '~/src/dash/components/model-dialog-custom-styles';
import { ModelDialogDeleteView } from '~/src/dash/components/model-dialog-delete-view';
import { ModelDialogMultiActive } from '~/src/dash/components/model-dialog-multi-active';
import { ModelSwitchView } from '~/src/dash/components/model-switch-view';
import { ModelTopBar } from '~/src/dash/components/model-topbar';
import { TIMEZONES } from '~/src/dash/globals/timezone';
import {
  Col,
  Cols,
  ct,
  Div,
  IndependentSelect,
  IndependentSelectV2,
  Panel,
  Panels,
  Row,
  Rows,
  spacing,
  Span,
  Text,
  TextInput,
} from '~/src/dash/publicaUI';
import { SESSION_ACTIONS_SET } from '~/src/dash/reducers/session-reducers';
import { IStore } from '~/src/dash/reducers/store';
import { isRoku } from '~/src/dash/resellers/utils/importResellerConfig';
import { getResellerTitle } from '~/src/dash/resellers/utils/importResellerConfig';
import { extractRouteParams, getRoutePath, RoutePublisherSettings } from '~/src/dash/router/routes';
import { IMenuList } from '~/src/dash/types/menuList';
import {
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { publicaColors } from '~/src/dash/utils/colors';
import {
  formatDateFromUTCToOffset,
  formatDateWithOffsetToUTC,
  parseDate,
  toEndDate,
  toStartDate,
} from '~/src/dash/utils/date';
import { decorate } from '~/src/dash/utils/decorator';
import {
  genDemandSourcesOptions,
  getHeaderBidderAdaptersForPublisher,
  IHeaderBidderAdapter,
} from '~/src/dash/utils/header-bidder-adapters';
import { IS_AUTHORIZED } from '~/src/dash/utils/permission_service';
import { getThirdPartyDataSharingItems } from '~/src/dash/utils/post-bid-data-share';
import { PID } from '~/src/dash/utils/publishers';
import {
  checkUserInfoMasked,
  hasRole,
  hasRoleAdmin,
  hasRoleSuperUser,
  ROLE_RESELLER,
} from '~/src/dash/utils/roles';
import { routeName } from '~/src/dash/utils/routes';
import { isPhiloPublisher, isSamsungPublisher } from '~/src/dash/utils/ui';
import { hasErrors, IErrors, transformErrors, validatorFactory } from '~/src/dash/utils/validator';
import { EPublisherType } from '~/src/dash/views/platform-connect/common';
import { SnackbarView } from '~/src/dash/views/snackbar-view';
import { patchPublisherTrafficShaping } from '~/src/dash/apiV2/publisher/publisher';
import { querySmallBidders } from '~/src/dash/api/filters/bidders';
import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { PillSwitcherV2 } from '~/src/dash/components/tabs/PillSwitcherV2';
import { MaxUnderFloorType, MaxUnderFloorError } from '~/src/dash/views/common';
import { ESupportTier, publisherSupportTierDisplayedItems } from '~/src/dash/api/publisher';
import { ModalDialogCustomConfirmationView } from '~/src/dash/components/modal-dialog-custom-confirmation-view';

const longText: Record<string, CSS.Properties> = {
  hidden: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  display: {
    wordWrap: 'break-word',
  },
};

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {}

interface IState extends IModelBase {
  // publisher panel
  Name: string;
  Domain: string;
  Timezone: string;
  RokuSeatID: string;
  NetworkEnabled: EBool;
  NativeVastEnabled: EBool;
  CurrencyDisplayed: string;
  EnableIASDataSharing: EBool;
  IASDataSharing: string[];
  EnableDoubleVerifyDataSharing: EBool;
  DoubleVerifyDataSharing: string[];
  ExcludedReportingDimensions: string[];
  Reseller: IReseller;
  Resellers: IReseller[];
  DDMonitoring: boolean;
  AllowPublisherIrisAltContentID: EBool;
  AllowPublisherToEnableEleaAI: EBool;
  PremiumFeaturesSelectionEleaAI: string;
  adQualityToolsModalActive: boolean;
  PublisherDevelopmentManager: string;
  SupportTier: ESupportTier;
  SolutionsArchitect: string;
  EnableIASFirstPartyVASTTracking: EBool;
  IASAnID: number;
  EnableIASThirdPartyVASTTracking: EBool;
  ContextualSegmentEnabled: EBool;
  IrisClientToken: string;
  IrisContextualSegmentsEnabled: EBool;
  IASContextualSegmentsEnabled: EBool;
  ComscoreContextualSegmentsEnabled: EBool;
  EnableExtendedRewrites: EBool;
  EnablePlatformMarketplace: EBool;
  PublisherType: EPublisherType;
  LogSamplingEnabled: EBool;
  EnableAllCreativeScanForEleaAI: EBool;
  OpenPathEnabled: EBool;
  EnableGoogleAdxSSLCert: EBool;
  DisableCreativeBlocking: EBool;
  EnableAPSDedup: EBool;
  SmartFloorsEnabled: EBool;
  EnableOtherCurrency: EBool;
  EnableAPSDemand: EBool;
  EnableBulkAPIs: EBool;
  EnablePublicaVault: EBool;
  IsResellerPublisher: EBool;
  MRMEnrichmentMode: MRMEnrichmentMode;
  EnableMRMLabeling: boolean;
  EnableMRMDecisioning: boolean;

  // Bidder Tier Alias
  BidderTier1CustomName: string;
  BidderTier2CustomName: string;
  BidderTier3CustomName: string;
  BidderTier4CustomName: string;
  BidderTier5CustomName: string;
  BidderTier6CustomName: string;
  BidderTier7CustomName: string;
  BidderTier8CustomName: string;
  BidderTier9CustomName: string;
  BidderTier10CustomName: string;

  // free trial panel
  FreeTrialActive: string;
  FreeTrialStartDate: moment.Moment;
  FreeTrialEndDate: moment.Moment;

  count: number;
  loading: boolean;
  errors: IErrors;
  snackbarMessage: string;
  snackbarError: boolean;
  snackbarWarning: boolean;
  publisherAPIToken: string;
  publisherThirdPartyAPITokens: IThirdPartyAPIToken[];
  showToken: boolean;
  localizations: ILocalization[];
  localizationID: string;
  s3AccessPointTTD: IS3AccessPoint;
  s3AccessPointGeneral: IS3AccessPoint;

  // disabled in UI
  publishersList: IMenuList;
  refresh: number;
  modalActive: boolean;
  toActivateModalNames: string;
  toDeactivateModalNames: string;

  // SAML integration
  openSAMLIntegrationModal: SAMLIntegrationModal;
  EnableDirectLogin: EBool;
  SAMLDisplayName: string;
  SAMLIdentityProviderSSOURL: string;
  SAMLIdentityProviderIssuer: string;
  SAMLCertificate: string;
  SAMLAutoprovision: EBool;
  SAMLPermissionsRoleID: number;
  SAMLUUID: string;
  SAMLIdentityProvidersList: ISAMLIdentityProvider[];
  updateSAMLID: number;
  deleteSAMLModalActive: boolean;
  deleteSAMLIdentityProvider: ISAMLIdentityProvider;
  publisherPermissionsRoles: IRole[];

  // API Access Keys
  publisherAccessKey: string;
  publisherSecretKey: string;

  // delete modal
  deleteDealDemandPartnerModalActive: boolean;
  deleteDealDemandPartnerModalID: string;
  deleteDealDemandPartnerModalName: string;

  // deal demand partners
  DealDemandPartners: IDealDemandPartner[];
  openCreateDealDemandPartnerModal: boolean;
  dealDemandPartnerName: string;
  dealDemandPartnerCount: number;
  showDealDemandPartnerAPIToken: IBoolDictionary;

  EnableTrafficShaping: EBool;
  EnableSponsorshipMode: EBool;
  DefaultPublicaVaultConfig: IPublicaVaultConfig;
  BiddersList: ISelectOption[];

  // IAS IVT Blocklist
  EnableIASIVTBlocklist: EBool;
  IASIVTBlocklistTargetingAllInventory: EBool;
  IASIVTBlocklistTargetingHeaderbidder: EBool;
  IASIVTBlocklistSelectedBidderIDs: number[];
}

enum SAMLIntegrationModal {
  CLOSE = 0,
  OPEN_EDIT = 1,
}

export enum PremiumFeaturesSelectionEleaAI {
  ADOMAIN_ENRICHMENT = 1,
  LANGUAGE_ENRICHMENT = 2,
  CQA = 3,
}

const EBoolStatusItem = [
  {
    label: 'Disabled',
    value: 'False',
  },
  {
    label: 'Enabled',
    value: 'True',
  },
];

const FreeTrialStatusItem = [
  {
    label: 'Disabled',
    value: FreeTrialStatusDisabled,
  },
  {
    label: 'Enabled',
    value: FreeTrialStatusEnabled,
  },
];

const PublisherTypeItem = [
  {
    label: 'Buyer',
    value: EPublisherType.PUBLISHER_TYPE_BUYER,
  },
  {
    label: 'Seller',
    value: EPublisherType.PUBLISHER_TYPE_SELLER,
  },
  {
    label: 'Both',
    value: EPublisherType.PUBLISHER_TYPE_BOTH,
  },
];

const publisherForm: IFormItem[] = [
  { id: 'Name', label: 'Name', render: FormItemTypeText, required: true, disabled: true },
  { id: 'Domain', label: 'Domain', render: FormItemTypeText },
  {
    id: 'Timezone',
    label: 'Timezone',
    render: FormItemTypeSingleSelect,
    required: true,
    props: { items: TIMEZONES, filterHelperText: 'Search for timezone...' },
  },
  {
    id: 'CurrencyDisplayed',
    label: 'Currency Displayed',
    render: FormItemTypeSingleSelect,
    required: true,
    props: { items: CurrencyDisplayedItem },
  },
  {
    id: 'EnableIASFirstPartyVASTTracking',
    label: 'Enable Measurement',
    render: FormItemTypeSingleSelect,
    required: true,
    props: { items: EBoolStatusItem },
  },
];

const freeTrialForm: IFormItem[] = [
  {
    id: 'FreeTrialActive',
    label: 'Free Trial Enabled',
    render: FormItemTypeSingleSelect,
    required: true,
    props: { items: FreeTrialStatusItem },
  },
];

const bidderTierForm: IFormItem[] = [
  { id: 'BidderTier1CustomName', label: 'Tier 1 Alias', render: FormItemTypeText, required: false },
  { id: 'BidderTier2CustomName', label: 'Tier 2 Alias', render: FormItemTypeText, required: false },
  { id: 'BidderTier3CustomName', label: 'Tier 3 Alias', render: FormItemTypeText, required: false },
  { id: 'BidderTier4CustomName', label: 'Tier 4 Alias', render: FormItemTypeText, required: false },
  { id: 'BidderTier5CustomName', label: 'Tier 5 Alias', render: FormItemTypeText, required: false },
  { id: 'BidderTier6CustomName', label: 'Tier 6 Alias', render: FormItemTypeText, required: false },
  { id: 'BidderTier7CustomName', label: 'Tier 7 Alias', render: FormItemTypeText, required: false },
  { id: 'BidderTier8CustomName', label: 'Tier 8 Alias', render: FormItemTypeText, required: false },
  { id: 'BidderTier9CustomName', label: 'Tier 9 Alias', render: FormItemTypeText, required: false },
  {
    id: 'BidderTier10CustomName',
    label: 'Tier 10 Alias',
    render: FormItemTypeText,
    required: false,
  },
];

const validate = validatorFactory({
  PublisherType(_val: any, _key: string, _obj: IObject): string {
    if (
      _obj.EnablePlatformMarketplace === EBool.EBool_TRUE &&
      _val !== EPublisherType.PUBLISHER_TYPE_BUYER &&
      _val !== EPublisherType.PUBLISHER_TYPE_SELLER &&
      _val !== EPublisherType.PUBLISHER_TYPE_BOTH
    ) {
      return 'needs Publisher Type if Platform Connection Enabled';
    }
    return '';
  },
});

const DialogWidth480 = createDialogWithCustomStyles({ paperWidthMd: { width: '480px' } });
const DialogWidth720 = createDialogWithCustomStyles({ paperWidthMd: { width: '720px' } });

/**
 * Returns true if the given MRMEnrichmentMode allows labeling.
 */
function isMRMEnrichmentModeAllowedLabeling(mode: MRMEnrichmentMode): boolean {
  return (
    mode === MRMEnrichmentMode.MRM_ENRICHMENT_MODE_LABELING ||
    mode === MRMEnrichmentMode.MRM_ENRICHMENT_MODE_STANDARD
  );
}

/**
 * Returns true if the given MRMEnrichmentMode allows decisioning.
 */
function isMRMEnrichmentModeAllowedDecisioning(mode: MRMEnrichmentMode): boolean {
  return (
    mode === MRMEnrichmentMode.MRM_ENRICHMENT_MODE_DECISIONING ||
    mode === MRMEnrichmentMode.MRM_ENRICHMENT_MODE_STANDARD
  );
}

function getMRMEnrichmentMode(
  enableLabeling: boolean,
  enableDecisioning: boolean,
): MRMEnrichmentMode {
  if (enableLabeling && enableDecisioning) {
    return MRMEnrichmentMode.MRM_ENRICHMENT_MODE_STANDARD;
  }
  if (enableLabeling) {
    return MRMEnrichmentMode.MRM_ENRICHMENT_MODE_LABELING;
  }
  if (enableDecisioning) {
    return MRMEnrichmentMode.MRM_ENRICHMENT_MODE_DECISIONING;
  }
  return MRMEnrichmentMode.MRM_ENRICHMENT_MODE_DISABLED;
}

export const PublisherSettingsView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    styles: (theme: any) =>
      createStyles({
        paper: {
          ...theme.mixins.gutters(),
          paddingTop: theme.spacing.unit * 2,
          paddingBottom: theme.spacing.unit * 2,
          marginTop: theme.spacing.unit * 4,
          marginRight: 'auto',
          marginLeft: 'auto',
          maxWidth: '600px',
        },
        modelSelectTextField: {
          margin: 0,
          width: '100%',
        },
      }),
    router: true,
  },
  class extends React.Component<IProps, IState> {
    state = {
      Name: this.props.session.publisher.Name,
      Domain: this.props.session.publisher.Domain,
      Timezone: this.props.session.publisher.Timezone,
      RokuSeatID: this.props.session.publisher.RokuSeatIDStr,
      NetworkEnabled: this.props.session.publisher.NetworkEnabled,
      NativeVastEnabled: this.props.session.publisher.NativeVastEnabled,
      EnableIASDataSharing: this.props.session.publisher.EnableIASDataSharing,
      IASDataSharing: this.props.session.publisher.IASDataSharing,
      EnableDoubleVerifyDataSharing: this.props.session.publisher.EnableDoubleVerifyDataSharing,
      DoubleVerifyDataSharing: this.props.session.publisher.DoubleVerifyDataSharing,
      ExcludedReportingDimensions: this.props.session.publisher.ExcludedReportingDimensions,
      FreeTrialActive: this.props.session.publisher.FreeTrialActive,
      FreeTrialStartDate: formatDateFromUTCToOffset(
        this.props.session.publisher.FreeTrialStartDate,
        this.props.session.publisher.Timezone,
      ),
      FreeTrialEndDate: formatDateFromUTCToOffset(
        this.props.session.publisher.FreeTrialEndDate,
        this.props.session.publisher.Timezone,
      ),
      Reseller: this.props.session.publisher.Reseller,
      Resellers: [] as IReseller[],
      publishersList: {} as IMenuList,
      DDMonitoring: this.props.session.publisher.DDMonitoring,
      AllowPublisherIrisAltContentID: this.props.session.publisher.AllowPublisherIrisAltContentID,
      AllowPublisherToEnableEleaAI: this.props.session.publisher.AllowPublisherToEnableEleaAI,
      PremiumFeaturesSelectionEleaAI: this.props.session.publisher.PremiumFeaturesSelectionEleaAI,
      adQualityToolsModalActive: false,
      // Bidder tiers 7 - 10 do not support custom names (HB-3071)
      BidderTier1CustomName: this.props.session.publisher.BidderTier1CustomName,
      BidderTier2CustomName: this.props.session.publisher.BidderTier2CustomName,
      BidderTier3CustomName: this.props.session.publisher.BidderTier3CustomName,
      BidderTier4CustomName: this.props.session.publisher.BidderTier4CustomName,
      BidderTier5CustomName: this.props.session.publisher.BidderTier5CustomName,
      BidderTier6CustomName: this.props.session.publisher.BidderTier6CustomName,
      BidderTier7CustomName: this.props.session.publisher.BidderTier7CustomName,
      BidderTier8CustomName: this.props.session.publisher.BidderTier8CustomName,
      BidderTier9CustomName: this.props.session.publisher.BidderTier9CustomName,
      BidderTier10CustomName: this.props.session.publisher.BidderTier10CustomName,
      ID: '0',
      count: 0,
      loading: false,
      errors: {} as IErrors,
      snackbarMessage: '',
      snackbarError: false,
      snackbarWarning: false,
      publisherAPIToken: '',
      publisherThirdPartyAPITokens: [],
      showToken: false,
      localizations: [] as ILocalization[],
      localizationID: this.props.session.publisher.Localization.ID,
      s3AccessPointTTD: {
        PublisherID: parseInt(this.props.user.publisher.ID, 10),
        BucketName: '',
        Region: '',
        FileDestination: '',
        SecretKey: '',
        AccessKey: '',
        IsAccessPointTTD: EBool.EBool_TRUE,
      } as IS3AccessPoint,
      s3AccessPointGeneral: {
        PublisherID: parseInt(this.props.user.publisher.ID, 10),
        BucketName: '',
        Region: 'us-east-1',
        FileDestination: '',
        SecretKey: '',
        AccessKey: '',
        IsAccessPointTTD: EBool.EBool_FALSE,
      } as IS3AccessPoint,
      CurrencyDisplayed: convertECurrencyTypeToString(
        this.props.session.publisher.CurrencyDisplayed,
      ),
      EnableOtherCurrency: this.props.session.publisher.EnableOtherCurrency,
      EnableAPSDemand: this.props.session.publisher.EnableAPSDemand,
      EnableBulkAPIs: this.props.session.publisher.EnableBulkAPIs,
      EnablePublicaVault: this.props.session.publisher.EnablePublicaVault,
      IsResellerPublisher: this.props.session.publisher.IsResellerPublisher,
      refresh: 0,
      modalActive: false,
      toActivateModalNames: '',
      toDeactivateModalNames: '',
      PublisherDevelopmentManager: this.props.session.publisher.PublisherDevelopmentManager,
      SupportTier: this.props.session.publisher.SupportTier,
      SolutionsArchitect: this.props.session.publisher.SolutionsArchitect,
      EnableIASFirstPartyVASTTracking: this.props.session.publisher.EnableIASFirstPartyVASTTracking,
      IASAnID: this.props.session.publisher.IASAnID,
      EnableIASThirdPartyVASTTracking: this.props.session.publisher.EnableIASThirdPartyVASTTracking,
      ContextualSegmentEnabled: this.props.session.publisher.ContextualSegmentEnabled,
      IrisClientToken: this.props.session.publisher.IrisClientToken,
      IrisContextualSegmentsEnabled: this.props.session.publisher.IrisContextualSegmentsEnabled,
      IASContextualSegmentsEnabled: this.props.session.publisher.IASContextualSegmentsEnabled,
      ComscoreContextualSegmentsEnabled:
        this.props.session.publisher.ComscoreContextualSegmentsEnabled,
      EnableExtendedRewrites: this.props.session.publisher.EnableExtendedRewrites,
      EnablePlatformMarketplace: this.props.session.publisher.EnablePlatformMarketplace,
      PublisherType: this.props.session.publisher.PublisherType,
      LogSamplingEnabled: this.props.session.publisher.LogSamplingEnabled,
      EnableAllCreativeScanForEleaAI: this.props.session.publisher.EnableAllCreativeScanForEleaAI,
      OpenPathEnabled: this.props.session.publisher.OpenPathEnabled,
      EnableGoogleAdxSSLCert: this.props.session.publisher.EnableGoogleAdxSSLCert,
      SmartFloorsEnabled: this.props.session.publisher.SmartFloorsEnabled,
      DisableCreativeBlocking: this.props.session.publisher.DisableCreativeBlocking,
      EnableAPSDedup: this.props.session.publisher.EnableAPSDedup,
      openSAMLIntegrationModal: SAMLIntegrationModal.CLOSE,
      EnableDirectLogin: this.props.session.publisher.EnableDirectLogin,
      SAMLDisplayName: '',
      SAMLIdentityProviderSSOURL: '',
      SAMLIdentityProviderIssuer: '',
      SAMLCertificate: '',
      SAMLAutoprovision: EBool.EBool_FALSE,
      SAMLPermissionsRoleID: 0,
      SAMLUUID: '',
      SAMLIdentityProvidersList: [] as ISAMLIdentityProvider[],
      updateSAMLID: 0,
      deleteSAMLModalActive: false,
      deleteSAMLIdentityProvider: {} as ISAMLIdentityProvider,
      publisherPermissionsRoles: undefined as unknown as IRole[],
      publisherAccessKey: this.props.session.publisher.PublisherAccessKey,
      publisherSecretKey: this.props.session.publisher.PublisherSecretKey,
      deleteDealDemandPartnerModalActive: false,
      deleteDealDemandPartnerModalID: '',
      deleteDealDemandPartnerModalName: '',
      DealDemandPartners: [] as IDealDemandPartner[],
      openCreateDealDemandPartnerModal: false,
      dealDemandPartnerName: '',
      dealDemandPartnerCount: 0,
      showDealDemandPartnerAPIToken: {} as IBoolDictionary,
      EnableTrafficShaping: this.props.session.publisher.EnableTrafficShaping,
      EnableSponsorshipMode: this.props.session.publisher.EnableSponsorshipMode,
      DefaultPublicaVaultConfig:
        this.props.session.publisher.DefaultPublicaVaultConfig ?? DEFAULT_PUBLICA_VAULT_CONFIG,
      BiddersList: [] as ISelectOption[],
      MRMEnrichmentMode: this.props.session.publisher.MRMEnrichmentMode,
      EnableMRMLabeling: isMRMEnrichmentModeAllowedLabeling(
        this.props.session.publisher.MRMEnrichmentMode,
      ),
      EnableMRMDecisioning: isMRMEnrichmentModeAllowedDecisioning(
        this.props.session.publisher.MRMEnrichmentMode,
      ),
      EnableIASIVTBlocklist: this.props.session.publisher.EnableIASIVTBlocklist,
      IASIVTBlocklistTargetingAllInventory:
        this.props.session.publisher.IASIVTBlocklistTargetingAllInventory,
      IASIVTBlocklistTargetingHeaderbidder:
        this.props.session.publisher.IASIVTBlocklistTargetingHeaderbidder,
      IASIVTBlocklistSelectedBidderIDs:
        this.props.session.publisher.IASIVTBlocklistSelectedBidderIDs ?? [],
    } as IState;

    _getResellers(count: number) {
      if (!hasRoleSuperUser(this.props.user.user)) {
        return;
      }
      if (count !== this.state.count) {
        return;
      }
      getResellers().then(
        (Resellers: IReseller[]) => {
          if (count !== this.state.count) {
            return;
          }
          this.setState({
            Resellers,
            loading: false,
          });
        },
        () => {
          if (count !== this.state.count) {
            return;
          }
          this.setState({
            Resellers: [],
          });
        },
      );
    }

    _getDealDemandPartners(dealDemandPartnerCount: number) {
      if (!hasRoleSuperUser(this.props.user.user)) {
        return;
      }
      if (dealDemandPartnerCount !== this.state.dealDemandPartnerCount) {
        return;
      }
      getDealDemandPartners().then(([DealDemandPartners, err]) => {
        if (err || !DealDemandPartners) {
          if (dealDemandPartnerCount !== this.state.dealDemandPartnerCount) {
            return;
          }
          this.setState({
            DealDemandPartners: [],
          });
        } else {
          if (dealDemandPartnerCount !== this.state.dealDemandPartnerCount) {
            return;
          }
          this.setState({
            DealDemandPartners: DealDemandPartners || ([] as IDealDemandPartner[]),
          });
        }
      });
    }

    componentDidMount() {
      if (hasRoleSuperUser(this.props.user.user)) {
        this.getResellers();
        this.getDealDemandPartners();
      }
      this.getLocalizations();
      this.getS3AccessPoint(EBool.EBool_TRUE);
      this.getS3AccessPoint(EBool.EBool_FALSE);
      this.handleFreeTrialDates();
      this.generatePublisherList();
      this.getPublisherPermissionsRoles();
      this.getSAMLIdentityProvider();
      this.generateBiddersList();
      getPublisherAPIToken(this.props.session.publisher.ID)
        .then((token: string) => {
          this.setState({
            publisherAPIToken: token,
          });
        })
        .catch((err) => {
          console.error(err);
          // don't show this error for the demo account, it will fail due to guard handler on API
          if (!checkUserInfoMasked(this.props.user.user)) {
            this.setState({
              snackbarMessage: 'Get publisher third party api tokens failed.',
              snackbarError: true,
              snackbarWarning: false,
            });
          }
        });

      getPublisherThirdPartyAPITokens(this.props.session.publisher.ID)
        .then((tokens: Array<IThirdPartyAPIToken>) => {
          this.setState({
            publisherThirdPartyAPITokens: tokens,
          });
        })
        .catch((err) => {
          console.error(err);
          // don't show this error for the demo account, it will fail due to guard handler on API
          if (!checkUserInfoMasked(this.props.user.user)) {
            this.setState({
              snackbarMessage: 'Get publisher third party api tokens failed.',
              snackbarError: true,
              snackbarWarning: false,
            });
          }
        });
    }

    generatePublisherList = () => {
      queryPublishers({
        query: {
          only_prebids: 1,
          publisher_id: this.props.user.publisher.ID,
        },
      })
        .then((publishers: IPublisher[]) => {
          const publishersList = {} as IMenuList;
          for (const pub of publishers) {
            // ignore parent pub
            if (!this.isResellerParentPub(pub.ID)) {
              publishersList[pub.ID] = {
                title: pub.Name,
                selected: pub.Active === ResourceActiveEnabled,
                originalValueSelected: pub.Active === ResourceActiveEnabled,
                ID: pub.ID.toString(),
              };
            }
          }
          this.setState({
            publishersList,
          });
        })
        .catch((err) => {
          console.error(err);
        });
    };

    generateBiddersList = (): void => {
      querySmallBidders(this.props.user.publisher.ID, {
        publisher_id: this.props.user.publisher.ID,
        site_ids: '',
      })
        .then((result) => {
          const bidders: ISelectOption[] = [];
          for (const bidder of result.HeaderBidders) {
            if (EBool.isTrue(bidder.Active)) {
              bidders.push({
                id: bidder.ID,
                label: bidder.Name,
              });
            }
          }
          this.setState({
            BiddersList: bidders,
          });
        })
        .catch(() => {
          this.setState({
            snackbarError: true,
            snackbarMessage: 'Error retrieving Bidders List',
          });
        });
    };

    componentDidReceiveProps(nextProps: IProps): void {
      const publisher = nextProps.session.publisher;
      this.setState({
        Name: publisher.Name,
        Domain: publisher.Domain,
        Timezone: publisher.Timezone,
        EnableIASDataSharing: publisher.EnableIASDataSharing,
        IASDataSharing: publisher.IASDataSharing,
        EnableDoubleVerifyDataSharing: publisher.EnableDoubleVerifyDataSharing,
        DoubleVerifyDataSharing: publisher.DoubleVerifyDataSharing,
        ExcludedReportingDimensions: publisher.ExcludedReportingDimensions,
        DDMonitoring: publisher.DDMonitoring,
        AllowPublisherIrisAltContentID: publisher.AllowPublisherIrisAltContentID,
        AllowPublisherToEnableEleaAI: publisher.AllowPublisherToEnableEleaAI,
        PremiumFeaturesSelectionEleaAI: publisher.PremiumFeaturesSelectionEleaAI,
        EnableIASFirstPartyVASTTracking: publisher.EnableIASFirstPartyVASTTracking,
        IASAnID: publisher.IASAnID,
        EnableIASThirdPartyVASTTracking: publisher.EnableIASThirdPartyVASTTracking,
        ContextualSegmentEnabled: publisher.ContextualSegmentEnabled,
        IrisClientToken: publisher.IrisClientToken,
        IrisContextualSegmentsEnabled: publisher.IrisContextualSegmentsEnabled,
        IASContextualSegmentsEnabled: publisher.IASContextualSegmentsEnabled,
        ComscoreContextualSegmentsEnabled: publisher.ComscoreContextualSegmentsEnabled,
        EnableExtendedRewrites: publisher.EnableExtendedRewrites,
        CurrencyDisplayed: convertECurrencyTypeToString(publisher.CurrencyDisplayed),
        EnablePlatformMarketplace: publisher.EnablePlatformMarketplace,
        PublisherType: publisher.PublisherType,
        LogSamplingEnabled: publisher.LogSamplingEnabled,
        EnableAllCreativeScanForEleaAI: publisher.EnableAllCreativeScanForEleaAI,
        OpenPathEnabled: publisher.OpenPathEnabled,
        EnableGoogleAdxSSLCert: publisher.EnableGoogleAdxSSLCert,
        DisableCreativeBlocking: publisher.DisableCreativeBlocking,
        EnableAPSDedup: publisher.EnableAPSDedup,
        SmartFloorsEnabled: publisher.SmartFloorsEnabled,
        EnableOtherCurrency: publisher.EnableOtherCurrency,
        EnableAPSDemand: publisher.EnableAPSDemand,
        EnableBulkAPIs: publisher.EnableBulkAPIs,
        EnablePublicaVault: publisher.EnablePublicaVault,
        EnableSponsorshipMode: publisher.EnableSponsorshipMode,
        IsResellerPublisher: publisher.IsResellerPublisher,
        MRMEnrichmentMode: publisher.MRMEnrichmentMode,
        EnableMRMLabeling: isMRMEnrichmentModeAllowedLabeling(publisher.MRMEnrichmentMode),
        EnableMRMDecisioning: isMRMEnrichmentModeAllowedDecisioning(publisher.MRMEnrichmentMode),
      });
    }

    validateForm = (): string => {
      const errors = validate(this.state);
      if (hasErrors(errors)) {
        console.warn("Can't save publisher settings:", errors);
        this.setState({
          errors,
        });
        return (
          'Errors: ' +
          Object.values(errors)
            .filter((val: string) => val.length > 0)
            .join(', ')
        );
      }
      this.setState({
        errors: {} as IErrors,
      });
      return '';
    };

    onUpdatePublisher = (data: IFormData) => {
      this.setState({
        Name: data.Name,
        Domain: data.Domain,
        Timezone: data.Timezone,
        NativeVastEnabled: data.NativeVastEnabled === 'True' ? EBool.EBool_TRUE : EBool.EBool_FALSE,
        NetworkEnabled: data.NetworkEnabled === 'True' ? EBool.EBool_TRUE : EBool.EBool_FALSE,
        EnableIASDataSharing:
          data.EnableIASDataSharing === 'True' ? EBool.EBool_TRUE : EBool.EBool_FALSE,
        EnableDoubleVerifyDataSharing:
          data.EnableDoubleVerifyDataSharing === 'True' ? EBool.EBool_TRUE : EBool.EBool_FALSE,
        ContextualSegmentEnabled:
          data.ContextualSegmentEnabled === 'True' ? EBool.EBool_TRUE : EBool.EBool_FALSE,
        IrisContextualSegmentsEnabled:
          data.IrisContextualSegmentsEnabled === 'True' ? EBool.EBool_TRUE : EBool.EBool_FALSE,
        IASContextualSegmentsEnabled:
          data.IASContextualSegmentsEnabled === 'True' ? EBool.EBool_TRUE : EBool.EBool_FALSE,
        ComscoreContextualSegmentsEnabled:
          data.ComscoreContextualSegmentsEnabled === 'True' ? EBool.EBool_TRUE : EBool.EBool_FALSE,
        EnableExtendedRewrites:
          data.EnableExtendedRewrites === 'True' ? EBool.EBool_TRUE : EBool.EBool_FALSE,
        EnableIASFirstPartyVASTTracking:
          data.EnableIASFirstPartyVASTTracking === 'True' ? EBool.EBool_TRUE : EBool.EBool_FALSE,
        IASAnID: data.IASAnID !== '' ? parseInt(data.IASAnID, 10) : 0,
        EnableIASThirdPartyVASTTracking:
          data.EnableIASThirdPartyVASTTracking === 'True' ? EBool.EBool_TRUE : EBool.EBool_FALSE,
        IrisClientToken: data.IrisClientToken,
        IASDataSharing: data.IASDataSharing,
        DoubleVerifyDataSharing: data.DoubleVerifyDataSharing,
        ExcludedReportingDimensions: data.ExcludedReportingDimensions,
        CurrencyDisplayed: data.CurrencyDisplayed,
        EnableOtherCurrency: data.EnableOtherCurrency,
        EnableAPSDemand: data.EnableAPSDemand,
        EnableBulkAPIs: data.EnableBulkAPIs,
        EnablePublicaVault: data.EnablePublicaVault as EBool,
        IsResellerPublisher: data.IsResellerPublisher as EBool,
        RokuSeatID: data.RokuSeatID,
        PublisherDevelopmentManager: data.PublisherDevelopmentManager,
        SupportTier: Number(data.SupportTier) as ESupportTier,
        SolutionsArchitect: data.SolutionsArchitect,
        EnablePlatformMarketplace:
          data.EnablePlatformMarketplace === 'True' ? EBool.EBool_TRUE : EBool.EBool_FALSE,
        PublisherType: convertStringToPublisherType(data.PublisherType),
        LogSamplingEnabled:
          data.LogSamplingEnabled === 'True' ? EBool.EBool_TRUE : EBool.EBool_FALSE,
        EnableAllCreativeScanForEleaAI:
          data.EnableAllCreativeScanForEleaAI === 'True' ? EBool.EBool_TRUE : EBool.EBool_FALSE,
        OpenPathEnabled: data.OpenPathEnabled === 'True' ? EBool.EBool_TRUE : EBool.EBool_FALSE,
        EnableGoogleAdxSSLCert:
          data.EnableGoogleAdxSSLCert === 'True' ? EBool.EBool_TRUE : EBool.EBool_FALSE,
        SmartFloorsEnabled:
          data.SmartFloorsEnabled === 'True' ? EBool.EBool_TRUE : EBool.EBool_FALSE,
        DisableCreativeBlocking: EBool.fromBoolString(data.DisableCreativeBlocking),
        EnableAPSDedup: EBool.fromBoolString(data.EnableAPSDedup),
        EnableSponsorshipMode: data.EnableSponsorshipMode as EBool,
        MRMEnrichmentMode: data.MRMEnrichmentMode as MRMEnrichmentMode,
      });
    };

    onUpdateBidderTier = (data: IFormData) => {
      this.setState({
        BidderTier1CustomName: data.BidderTier1CustomName,
        BidderTier2CustomName: data.BidderTier2CustomName,
        BidderTier3CustomName: data.BidderTier3CustomName,
        BidderTier4CustomName: data.BidderTier4CustomName,
        BidderTier5CustomName: data.BidderTier5CustomName,
        BidderTier6CustomName: data.BidderTier6CustomName,
        BidderTier7CustomName: data.BidderTier7CustomName,
        BidderTier8CustomName: data.BidderTier8CustomName,
        BidderTier9CustomName: data.BidderTier9CustomName,
        BidderTier10CustomName: data.BidderTier10CustomName,
      });
    };

    onUpdateLocalization = (data: IFormData) => {
      this.setState({
        localizationID: data.Localization,
      });
    };

    onUpdateDefaultPublicaVaultConfig = (
      data: Set<string | number> | ChangeEvent<HTMLInputElement> | string | boolean,
      id: string,
    ): void => {
      const newDefaultPublicaVaultConfig = this.state.DefaultPublicaVaultConfig;
      if (id === 'TTL') {
        newDefaultPublicaVaultConfig.TTL = Array.from(data as Set<number>)[0];
      } else if (id === 'EnableByDefault') {
        newDefaultPublicaVaultConfig.EnableByDefault = data as boolean;
      } else if (id === 'ExcludedDemandSources') {
        newDefaultPublicaVaultConfig.ExcludedDemandSources = Array.from(data as Set<string>).join(
          ',',
        );
      } else if (id === 'ExcludedBidderIDs') {
        newDefaultPublicaVaultConfig.ExcludedBidderIDs = Array.from(data as Set<string>).join(',');
      } else if (id === 'ContentId') {
        const target = (data as ChangeEvent<HTMLInputElement>).target;
        newDefaultPublicaVaultConfig.ContentId = target.checked;
      } else if (id === 'AppBundle') {
        const target = (data as ChangeEvent<HTMLInputElement>).target;
        newDefaultPublicaVaultConfig.AppBundle = target.checked;
      } else if (id === 'StoreBelowFloorBids') {
        newDefaultPublicaVaultConfig.StoreBelowFloorBids = data as boolean;
      } else if (id === 'MaxUnderFloorType') {
        newDefaultPublicaVaultConfig.MaxUnderFloorType = data
          ? MaxUnderFloorType.Percent
          : MaxUnderFloorType.Currency;
      } else if (id === 'MaxUnderFloorValue') {
        newDefaultPublicaVaultConfig.MaxUnderFloorValue = Number(data);
      }

      this.setState({
        DefaultPublicaVaultConfig: newDefaultPublicaVaultConfig,
      });
    };

    onUpdateIASIVTBlocklistSelectedBidderIDs = (data: Set<string | number>): void => {
      this.setState({
        IASIVTBlocklistSelectedBidderIDs: [...data].map(Number),
      });
    };

    onUpdatePublisherAccessKeys = (data: IFormData) => {
      this.setState({
        publisherAccessKey: data.PublisherAccessKey,
        publisherSecretKey: data.PublisherSecretKey,
      });
    };

    onUpdateFreeTrial = (data: IFormData) => {
      this.setState({
        FreeTrialActive: data.FreeTrialActive,
      });
    };

    handleSnackbar = (
      snackbarMessage: string,
      snackbarError: boolean,
      snackbarWarning: boolean,
    ) => {
      this.setState({
        snackbarMessage,
        snackbarError,
        snackbarWarning,
      });
    };

    handleFreeTrialDates = () => {
      // if free trial dates are null, provide default period of two weeks starting with current day
      const defaultTrialStartDate = new Date().toISOString();

      const twoWeeks = 1000 * 60 * 60 * 24 * 14;
      const twoWeeksTime = new Date(new Date().getTime() + twoWeeks);
      const defaultTrialEndDate = twoWeeksTime.toISOString();

      let startDate = toStartDate(parseDate(defaultTrialStartDate));
      let endDate = toEndDate(parseDate(defaultTrialEndDate));

      if (
        this.props.session.publisher.FreeTrialStartDate &&
        this.props.session.publisher.FreeTrialStartDate !== 'null'
      ) {
        startDate = formatDateFromUTCToOffset(
          this.props.session.publisher.FreeTrialStartDate,
          this.props.session.publisher.Timezone,
        );
      }
      if (
        this.props.session.publisher.FreeTrialEndDate &&
        this.props.session.publisher.FreeTrialEndDate !== 'null'
      ) {
        endDate = formatDateFromUTCToOffset(
          this.props.session.publisher.FreeTrialEndDate,
          this.props.session.publisher.Timezone,
        );
      }
      this.setState({
        FreeTrialStartDate: startDate,
        FreeTrialEndDate: endDate,
      });
    };

    handleDateChange = ({ start, end }: IDateRangeChangeEvent) => {
      this.setState({
        FreeTrialStartDate: start,
        FreeTrialEndDate: end,
      });
    };

    getResellers() {
      const count = this.state.count + 1;
      this.setState(
        {
          loading: true,
          count,
        },
        () => {
          this._getResellers(count);
        },
      );
    }

    getDealDemandPartners() {
      const dealDemandPartnerCount = this.state.dealDemandPartnerCount + 1;
      this.setState(
        {
          loading: true,
          dealDemandPartnerCount,
        },
        () => {
          this._getDealDemandPartners(dealDemandPartnerCount);
        },
      );
    }

    getLocalizations() {
      getLocalizations().then(({ localizations }: { localizations: ILocalization[] }) => {
        this.setState({ localizations });
      });
    }

    getS3AccessPoint(isAccessPointTTD: EBool) {
      getS3AccessPoint(this.props.user.publisher.ID, isAccessPointTTD)
        .then((val: IHttpResponse<IS3AccessPoint>) => {
          if (EBool.isTrue(isAccessPointTTD)) {
            this.setState({
              s3AccessPointTTD: val.parsedBody as IS3AccessPoint,
            });
          } else {
            this.setState({
              s3AccessPointGeneral: {
                ...val.parsedBody,
                Region: (val.parsedBody as IS3AccessPoint)?.Region || 'us-east-1',
              } as IS3AccessPoint,
            });
          }
        })
        .catch(() => {
          const accessPointPrefix = EBool.isTrue(isAccessPointTTD) ? 'The Trade Desk' : 'General';
          this.setState({
            snackbarError: true,
            snackbarMessage: `Error while getting ${accessPointPrefix} S3 Access Point`,
          });
        });
    }

    onUpdateS3AccessPoint = (data: IFormData, isAccessPointTTD: EBool) => {
      const s3AccessPoint = {
        PublisherID: parseInt(this.props.user.publisher.ID, 10),
        BucketName: data.BucketName || '',
        Region: data.Region || '',
        FileDestination: data.FileDestination || '',
        SecretKey: data.SecretKey || '',
        AccessKey: data.AccessKey || '',
        IsAccessPointTTD: isAccessPointTTD,
      } as IS3AccessPoint;
      if (EBool.isTrue(isAccessPointTTD)) {
        this.setState({
          s3AccessPointTTD: s3AccessPoint,
        });
      } else {
        this.setState({
          s3AccessPointGeneral: s3AccessPoint,
        });
      }
    };

    createOrUpdateS3AccessPoint = (done: (err?: Error) => void) => (isAccessPointTTD: EBool) => {
      let accessPoint;
      if (EBool.isTrue(isAccessPointTTD)) {
        accessPoint = this.state.s3AccessPointTTD;
      } else {
        accessPoint = this.state.s3AccessPointGeneral;
      }

      const accessPointPrefix = EBool.isTrue(isAccessPointTTD) ? 'The Trade Desk' : 'General';
      if (accessPoint.BucketName === '') {
        this.setState({
          snackbarError: true,
          snackbarMessage: `${accessPointPrefix} S3 Access Point must have a bucket name`,
        });
        return;
      }
      if (accessPoint.Region === '') {
        this.setState({
          snackbarError: true,
          snackbarMessage: `${accessPointPrefix} S3 Access Point must have a region`,
        });
        return;
      }
      if (accessPoint.FileDestination === '') {
        this.setState({
          snackbarError: true,
          snackbarMessage: `${accessPointPrefix} S3 Access Point must have a file destination`,
        });
        return;
      }
      if (accessPoint.AccessKey === '') {
        this.setState({
          snackbarError: true,
          snackbarMessage: `${accessPointPrefix} S3 Access Point must have an Access Key`,
        });
        return;
      }
      if (accessPoint.SecretKey === '') {
        this.setState({
          snackbarError: true,
          snackbarMessage: `${accessPointPrefix} S3 Access Point must have a Secret Key`,
        });
        return;
      }

      createOrUpdateS3AccessPoint(accessPoint, isAccessPointTTD)
        .then((val: IHttpResponse<IS3AccessPoint>) => {
          const accessPointPrefix = EBool.isTrue(isAccessPointTTD) ? 'The Trade Desk' : 'General';
          if (EBool.isTrue(isAccessPointTTD)) {
            this.setState(
              {
                s3AccessPointTTD: val.parsedBody as IS3AccessPoint,
                snackbarMessage: `Successfully saved ${accessPointPrefix} S3 Access Point`,
              },
              done,
            );
          } else {
            this.setState(
              {
                s3AccessPointGeneral: val.parsedBody as IS3AccessPoint,
                snackbarMessage: `Successfully saved ${accessPointPrefix} S3 Access Point`,
              },
              done,
            );
          }
        })
        .catch((err) => {
          console.error(err);
          const accessPointPrefix = EBool.isTrue(isAccessPointTTD) ? 'The Trade Desk' : 'General';
          this.setState({
            snackbarError: true,
            snackbarMessage: `Error while saving the ${accessPointPrefix} S3 Access Point`,
          });
        });
    };

    getPublisherForm() {
      let formBase = cloneDeep(publisherForm);
      // enable editing the name field only for super users
      if (hasRoleSuperUser(this.props.user.user)) {
        formBase.find((item) => item.id === 'Name')!.disabled = false;
      }
      if (this.state.EnableIASDataSharing === EBool.EBool_TRUE) {
        formBase = formBase.concat([
          {
            id: 'IASDataSharing',
            label: 'Post Bid Advertiser Reporting (IAS)',
            render: FormItemTypeMultiSelect,
            required: true,
            props: { items: getThirdPartyDataSharingItems() },
          },
        ]);
      }
      if (this.state.EnableDoubleVerifyDataSharing === EBool.EBool_TRUE) {
        formBase = formBase.concat([
          {
            id: 'DoubleVerifyDataSharing',
            label: 'Post Bid Advertiser Reporting (DoubleVerify)',
            render: FormItemTypeMultiSelect,
            required: true,
            props: { items: getThirdPartyDataSharingItems() },
          },
        ]);
      }
      if (isRoku()) {
        formBase = formBase.concat([
          {
            id: 'RokuSeatID',
            label: 'Roku Seat ID',
            required: true,
            render: FormItemTypeText,
          },
        ]);
      }
      if (hasRoleSuperUser(this.props.user.user)) {
        formBase = formBase.concat([
          {
            id: 'EnableIASDataSharing',
            label: 'Enable Post Bid Advertiser Reporting (IAS) *',
            render: FormItemTypeSingleSelect,
            required: true,
            props: {
              items: EBoolStatusItem,
            },
          },
          {
            id: 'EnableDoubleVerifyDataSharing',
            label: 'Enable Post Bid Advertiser Reporting (DoubleVerify) *',
            render: FormItemTypeSingleSelect,
            required: true,
            props: {
              items: EBoolStatusItem,
            },
          },
          {
            id: 'EnablePlatformMarketplace',
            label: 'Enable Platform Connect *',
            render: FormItemTypeSingleSelect,
            required: true,
            props: {
              items: EBoolStatusItem,
            },
          },
        ]);
        if (this.state.EnablePlatformMarketplace === EBool.EBool_TRUE) {
          formBase = formBase.concat([
            {
              id: 'PublisherType',
              label: 'Publisher Type *',
              render: FormItemTypeSingleSelect,
              required: true,
              props: {
                items: PublisherTypeItem,
              },
            },
          ]);
        }
        if (hasRoleSuperUser(this.props.user.user)) {
          formBase = formBase.concat([
            {
              id: 'ExcludedReportingDimensions',
              label: 'Excluded Reporting Dimensions *',
              render: FormItemTypeMultiSelect,
              required: true,
              props: { items: getExcludedReportingDimensionItems() },
            },
          ]);
        }
        formBase = formBase.concat([
          {
            id: 'ResellerID',
            label: 'Reseller *',
            render: FormItemTypeModelSelect,
            required: true,
            props: {
              model: this.state.Reseller.ID ? this.state.Reseller : undefined,
              models: this.state.Resellers,
              defaultText: '',
              onSelect: (model: IModel) => {
                this.setState({
                  Reseller: model as IReseller,
                });
              },
              TextFieldProps: {
                classes: {
                  root: this.props.classes.modelSelectTextField,
                },
              },
            },
          },
          {
            id: 'PublisherDevelopmentManager',
            label: 'Publisher Development Manager *',
            render: FormItemTypeText,
          },
          {
            id: 'SupportTier',
            label: 'Support Tier *',
            render: FormItemTypeSingleSelect,
            required: true,
            props: {
              items: publisherSupportTierDisplayedItems,
              disableAlphanumSort: true,
            },
          },
          {
            id: 'SolutionsArchitect',
            label: 'Solutions Architect *',
            render: FormItemTypeText,
          },
          {
            id: 'ContextualSegmentEnabled',
            label: 'Contextual Segment Enabled *',
            render: FormItemTypeSingleSelect,
            required: true,
            props: {
              items: EBoolStatusItem,
            },
          },
          {
            id: 'IASContextualSegmentsEnabled',
            label: 'IAS Contextual Segments Enabled *',
            render: FormItemTypeSingleSelect,
            required: true,
            props: {
              items: EBoolStatusItem,
            },
          },
          {
            id: 'EnableExtendedRewrites',
            label: 'Enable Extended Rewrites *',
            render: FormItemTypeSingleSelect,
            required: true,
            props: {
              items: EBoolStatusItem,
            },
          },
          {
            id: 'ComscoreContextualSegmentsEnabled',
            label: 'Comscore Contextual Segments Enabled  *',
            render: FormItemTypeSingleSelect,
            required: true,
            props: {
              items: EBoolStatusItem,
            },
          },
          {
            id: 'IrisContextualSegmentsEnabled',
            label: 'IRIS.TV Contextual Segments Enabled  *',
            render: FormItemTypeSingleSelect,
            required: true,
            props: {
              items: EBoolStatusItem,
            },
          },
          {
            id: 'IASAnID',
            label: 'IAS an_id *',
            render: FormItemTypeText,
          },
          {
            id: 'EnableIASThirdPartyVASTTracking',
            label: 'Enable IAS Third Party VAST Tracking *',
            render: FormItemTypeSingleSelect,
            required: true,
            props: {
              items: EBoolStatusItem,
            },
          },
          {
            id: 'IrisClientToken',
            label: 'IRIS.TV Client Token *',
            render: FormItemTypeText,
          },
        ]);
      }

      return formBase;
    }

    getPublisherPermissionsRoles = () => {
      const reqUrl = createUrl('/roles', this.props.session.publisher.ID);

      restGet<IRole[]>(reqUrl, {})
        .then((val: IHttpResponse<IRole[]>) => {
          this.setState({
            publisherPermissionsRoles: val.parsedBody as IRole[],
          });
        })
        .catch(() => {
          this.setState({
            publisherPermissionsRoles: [] as IRole[],
          });
        });
    };

    getSAMLIdentityProvider = () => {
      getSAMLIdentityProvider({
        query: {
          publisher_id: this.props.user.publisher.ID,
        },
      })
        .then((resp) => {
          this.setState({
            SAMLIdentityProvidersList: resp,
          });
        })
        .catch(() => {
          this.setState({
            snackbarMessage: 'Error getting SAML Identity Provider. Please try again later.',
            snackbarError: true,
            snackbarWarning: false,
          });
        });
    };

    renderAllowPublisherIrisAltContentID = () => {
      return (
        <div>
          <ModelSwitchView
            checked={EBool.toBool(this.state.AllowPublisherIrisAltContentID)}
            model={this.state}
            onChange={this.updateAllowPublisherIrisAltContentID}
          />
          Allow alternate Iris IDs *
        </div>
      );
    };

    updateAllowPublisherIrisAltContentID = (_: any, value: boolean) => {
      this.setState({
        AllowPublisherIrisAltContentID: EBool.fromBool(value),
      });
    };

    renderAdQualityToolsPremiumFeatures = (): React.JSX.Element => {
      const premiumFeaturesOptions: ISelectOption[] = [
        {
          id: PremiumFeaturesSelectionEleaAI.ADOMAIN_ENRICHMENT,
          label: ct('AdomainEnrichment'),
        },
        {
          id: PremiumFeaturesSelectionEleaAI.LANGUAGE_ENRICHMENT,
          label: ct('LanguageEnrichment'),
        },
        {
          id: PremiumFeaturesSelectionEleaAI.CQA,
          label: ct('CreativeQualityAssurance'),
        },
      ];

      return (
        <Row
          noVerticalPadding
          paddingLeft={spacing.huge}
          displayFlex
          style={{ alignItems: 'center' }}
        >
          <Text extraSmall style={{ paddingRight: spacing.base }} tKey='PremiumFeatures' />
          <IndependentSelectV2
            handleApplySelect={(data: Set<number>) =>
              this.updateAdQualityToolsPremiumFeatures(data)
            }
            selectKey='Features'
            labelTKey='Features'
            options={premiumFeaturesOptions}
            selectedOptionIDs={
              new Set(
                this.state.PremiumFeaturesSelectionEleaAI
                  ? this.state.PremiumFeaturesSelectionEleaAI.split(',').map(Number)
                  : [],
              )
            }
            key='features'
            maxWidth={200}
            popoverWidth={280}
            disableSearch
            selectedLimit={3}
          />
        </Row>
      );
    };

    updateAdQualityToolsPremiumFeatures = (data: Set<number>): void => {
      this.setState({
        PremiumFeaturesSelectionEleaAI: Array.from(data).join(','),
      });
    };

    renderAllowPublisherToEnableEleaAI = () => {
      return (
        <Grid container direction='column'>
          <Rows>
            <Row noPadding>
              <ModelSwitchView
                checked={EBool.toBool(this.state.AllowPublisherToEnableEleaAI)}
                model={this.state}
                onChange={this.updateAllowPublisherToEnableEleaAI}
              />
              {ct('EnablePremiumAdQualityToolsAccess')} *
            </Row>
            <Row noPadding>
              {EBool.toBool(this.state.AllowPublisherToEnableEleaAI) &&
                this.renderAdQualityToolsPremiumFeatures()}
            </Row>
          </Rows>
        </Grid>
      );
    };

    updateAllowPublisherToEnableEleaAI = (_: any, value: boolean) => {
      this.setState({
        AllowPublisherToEnableEleaAI: EBool.fromBool(value),
      });
    };

    renderDDMonitoring() {
      return (
        <div>
          <ModelSwitchView
            checked={this.state.DDMonitoring}
            model={this.state}
            onChange={this.updateDDMonitoring}
          />
          Enable DD Monitoring *
        </div>
      );
    }

    updateDDMonitoring = (_: any, value: boolean) => {
      this.setState({
        DDMonitoring: value,
      });
    };

    renderLoginMethods() {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div
            style={{
              width: '100%',
              padding: '5px 0 5px 0',
              marginLeft: '5px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography>Direct Login</Typography>
            <div style={{ display: 'flex' }}>
              <ModelSwitchView
                checked={this.state.EnableDirectLogin === EBool.EBool_TRUE}
                model={this.state}
                onChange={() => this.handleLoginMethodChange(0)}
              />
              <div style={{ width: '48px' }}> &nbsp; </div>
            </div>
          </div>

          {this.state.SAMLIdentityProvidersList.map((SAMLIdentityProvider) => {
            return (
              <div
                style={{
                  width: '100%',
                  padding: '5px 0 5px 0',
                  marginLeft: '5px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Button
                  style={{
                    textTransform: 'none',
                    fontSize: '16px',
                    fontWeight: 'normal',
                    padding: '0px',
                  }}
                  onClick={() => {
                    this.setState({
                      openSAMLIntegrationModal: SAMLIntegrationModal.OPEN_EDIT,
                      updateSAMLID: parseInt(SAMLIdentityProvider.ID, 10),
                      SAMLDisplayName: SAMLIdentityProvider.DisplayName,
                      SAMLIdentityProviderSSOURL: SAMLIdentityProvider.IdentityProviderSSOURL,
                      SAMLIdentityProviderIssuer: SAMLIdentityProvider.IdentityProviderIssuer,
                      SAMLCertificate: SAMLIdentityProvider.Certificate,
                      SAMLAutoprovision: SAMLIdentityProvider.Autoprovision,
                      SAMLPermissionsRoleID: SAMLIdentityProvider.PermissionsRoleID,
                      SAMLUUID: SAMLIdentityProvider.UUID,
                    });
                  }}
                >
                  SAML Display Name: {SAMLIdentityProvider.DisplayName}
                </Button>
                <div>
                  <ModelSwitchView
                    checked={SAMLIdentityProvider.Enabled === EBool.EBool_TRUE}
                    model={this.state}
                    onChange={() => {
                      this.handleLoginMethodChange(parseInt(SAMLIdentityProvider.ID, 10));
                    }}
                  />
                  <IconButton
                    aria-label='delete'
                    // enables modal for item deletion
                    onClick={() => {
                      this.setState({
                        deleteSAMLModalActive: true,
                        deleteSAMLIdentityProvider: SAMLIdentityProvider,
                      });
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </div>
              </div>
            );
          })}

          <div style={{ width: '95%', padding: '5px 0 20px 0' }}>
            <Grid item>
              <Button
                style={{ color: '#4952FF', textTransform: 'none', fontSize: '16px' }}
                onClick={this.createLoginMethod}
              >
                + SAML Integration
              </Button>
            </Grid>
          </div>
        </div>
      );
    }

    handleCloseCreateDealDemandPartnerDialog = () => {
      this.setState({ openCreateDealDemandPartnerModal: false });
    };

    handleCloseDeleteDealDemandPartnerDialog = (): void => {
      this.setState({
        deleteDealDemandPartnerModalActive: false,
        deleteDealDemandPartnerModalID: '',
        deleteDealDemandPartnerModalName: '',
      });
    };

    deleteDealDemandPartner = (partnerID: string) => {
      const { DealDemandPartners } = this.state;

      deleteDealDemandPartner(partnerID).then(([_, err]) => {
        if (!!err) {
          console.error(err);
          this.setState({
            snackbarMessage: 'Error while deleting deal demand partner',
            snackbarError: true,
          });
        } else {
          const filteredDealDemandPartners = DealDemandPartners.filter(
            (partner: IDealDemandPartner) => partner.ID.toString() !== partnerID,
          );
          this.setState({
            DealDemandPartners: filteredDealDemandPartners,
            snackbarMessage: 'Successfully deleted deal demand partner',
            snackbarError: false,
          });
        }
      });

      // the delete modal expects a promise to be returned
      return new Promise((resolve) => resolve(undefined));
    };

    renderDealDemandPartners = () => {
      const { DealDemandPartners, showDealDemandPartnerAPIToken } = this.state;
      return (
        <Panel scroll largePadding>
          <Grid container direction='column'>
            <Rows gap={spacing.small}>
              {DealDemandPartners.map((partner: IDealDemandPartner) => {
                return (
                  <Row noPadding>
                    <Cols gap={spacing.medium}>
                      <Col style={{ alignItems: 'left', width: '120px' }}>
                        <Text style={{ wordBreak: 'break-word' }}>{partner.Name}</Text>
                      </Col>
                      <Col style={{ alignItems: 'center', width: '265px' }}>
                        <Text
                          style={
                            !!showDealDemandPartnerAPIToken[partner.ID]
                              ? longText.display
                              : longText.hidden
                          }
                        >
                          {partner.APIToken}
                        </Text>
                      </Col>
                      <Col style={{ alignItems: 'right' }}>
                        <Cols gap={spacing.small} style={{ alignItems: 'center' }}>
                          <Col displayFlex>
                            <Tooltip title='Copy'>
                              <span>
                                <IconButton
                                  style={{ padding: 0 }}
                                  aria-label='copy'
                                  className='pb-list-table-deal-demand-partner-list_iconbutton-copy'
                                  // enables modal for item deletion
                                  onClick={() => {
                                    copy(partner.APIToken);
                                  }}
                                >
                                  <FileCopyIcon />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </Col>
                          <Col displayFlex>
                            <Tooltip
                              title={
                                !!this.state.showDealDemandPartnerAPIToken[partner.ID]
                                  ? 'Hide Token'
                                  : 'Show Token'
                              }
                            >
                              <span>
                                <IconButton
                                  style={{ padding: 0 }}
                                  aria-label='visibility'
                                  className='pb-list-table-deal-demand-partner-list_iconbutton-visibility'
                                  // enables modal for item deletion
                                  onClick={() => {
                                    const showDealDemandPartnerAPIToken = cloneDeep(
                                      this.state.showDealDemandPartnerAPIToken,
                                    );
                                    showDealDemandPartnerAPIToken[partner.ID] =
                                      !showDealDemandPartnerAPIToken[partner.ID];
                                    this.setState({
                                      showDealDemandPartnerAPIToken,
                                    });
                                  }}
                                >
                                  {!!this.state.showDealDemandPartnerAPIToken[partner.ID] ? (
                                    <VisibilityOffIcon />
                                  ) : (
                                    <VisibilityIcon />
                                  )}
                                </IconButton>
                              </span>
                            </Tooltip>
                          </Col>
                          <Col displayFlex>
                            <Tooltip title='Delete'>
                              <span>
                                <IconButton
                                  style={{ padding: 0 }}
                                  aria-label='delete'
                                  className='pb-list-table-deal-demand-partner-list_iconbutton-delete-'
                                  // enables modal for item deletion
                                  onClick={() => {
                                    this.setState({
                                      deleteDealDemandPartnerModalActive: true,
                                      deleteDealDemandPartnerModalID: partner.ID.toString(),
                                      deleteDealDemandPartnerModalName: partner.Name,
                                    });
                                  }}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </Col>
                        </Cols>
                      </Col>
                    </Cols>
                  </Row>
                );
              })}
            </Rows>
          </Grid>
          <div style={{ width: '95%', padding: '5px 0 20px 0' }}>
            <Grid item>
              <Button
                style={{ color: '#4952FF', textTransform: 'none', fontSize: '16px' }}
                onClick={() => {
                  this.setState({
                    openCreateDealDemandPartnerModal: true,
                  });
                }}
              >
                + Partner Token
              </Button>
            </Grid>
          </div>
        </Panel>
      );
    };

    handleChange = (elem: React.ChangeEvent<HTMLInputElement>) => {
      const { name, value } = elem.target;
      const immutableUpdate = set({}, name, { $set: value });
      const newState = update(this.state, immutableUpdate);
      this.setState(newState);
    };

    handleSAMLInput = (elem: React.ChangeEvent<HTMLInputElement>) => {
      const { name, value } = elem.target;
      const newState = set({}, name, value);
      this.setState(newState);
    };

    handleLoginMethodChange = (samlID: number) => {
      // if there's no other login methods saved, then we have to use Direct Login

      if (this.state.SAMLIdentityProvidersList.length === 0) {
        this.setState({
          EnableDirectLogin: EBool.EBool_TRUE,
        });
      } else if (samlID === 0) {
        this.setState({
          EnableDirectLogin:
            this.state.EnableDirectLogin === EBool.EBool_FALSE
              ? EBool.EBool_TRUE
              : EBool.EBool_FALSE,
        });
      } else {
        const SAMLIdentityProvidersList = this.state.SAMLIdentityProvidersList;
        const indexSaml = SAMLIdentityProvidersList.findIndex((SAMLIdProvider) => {
          return parseInt(SAMLIdProvider.ID, 10) === samlID;
        });
        if (SAMLIdentityProvidersList[indexSaml]) {
          if (
            SAMLIdentityProvidersList[indexSaml].Certificate.trim().length === 0 ||
            SAMLIdentityProvidersList[indexSaml].IdentityProviderIssuer.trim().length === 0 ||
            SAMLIdentityProvidersList[indexSaml].IdentityProviderSSOURL.trim().length === 0
          ) {
            this.setState({
              snackbarMessage: "Please update the login method's SAML information",
              snackbarError: true,
            });
            return;
          } else {
            SAMLIdentityProvidersList[indexSaml].Enabled === EBool.EBool_FALSE
              ? (SAMLIdentityProvidersList[indexSaml].Enabled = EBool.EBool_TRUE)
              : (SAMLIdentityProvidersList[indexSaml].Enabled = EBool.EBool_FALSE);
          }
        }
        this.setState({
          SAMLIdentityProvidersList,
        });
      }
    };

    handleCloseSAMLDeleteModal = () => {
      this.setState({
        deleteSAMLModalActive: false,
      });
    };

    renderNumberTextfield = (label: string, name: keyof IState) => {
      const { classes } = this.props;
      return (
        <Grid className={classes.optionRow} style={{ paddingLeft: 58 }}>
          <TextField
            style={{ width: 168 }}
            name={name}
            label={label}
            type='number'
            InputProps={{ inputProps: { min: 0.01, max: 1.0, step: 0.01, placeholder: '0.01' } }}
            value={this.state[name]}
            onChange={this.handleChange}
            helperText={this.state.errors[name]}
            error={!!this.state.errors[name]}
          />
        </Grid>
      );
    };

    renderPublisherLogSampling() {
      const checked = this.state.LogSamplingEnabled
        ? EBool.toBool(this.state.LogSamplingEnabled)
        : false;
      return (
        <>
          <Grid>
            <ModelSwitchView
              checked={checked}
              model={this.state}
              onChange={this.updatePublisherLogSampling}
              disabled={this.props.session.publisher.IsResellerPublisher === EBool.EBool_TRUE}
            />
            Enable Publisher Log Sampling *
            <Tooltip
              title={
                'For reseller publishers, this must be enabled/disabled and set in #ctv-sql-query-requests'
              }
              placement='top'
            >
              <InfoIcon
                style={{
                  verticalAlign: 'bottom',
                  width: '1rem',
                  color: '#929599',
                  marginLeft: '5px',
                  marginBottom: '8px',
                }}
              />
            </Tooltip>
          </Grid>
        </>
      );
    }

    updatePublisherLogSampling = (_: any, value: boolean) => {
      this.setState({
        LogSamplingEnabled: EBool.fromBool(value),
      });
    };

    renderEnableAllCreativeScanForEleaAI() {
      const checked = this.state.EnableAllCreativeScanForEleaAI
        ? EBool.toBool(this.state.EnableAllCreativeScanForEleaAI)
        : false;
      return (
        <Grid>
          <ModelSwitchView
            checked={checked}
            model={this.state}
            onChange={this.updateEnableAllCreativeScanForEleaAI}
          />
          Enable All Creative Scan For Elea AI *
        </Grid>
      );
    }

    updateEnableAllCreativeScanForEleaAI = (_: any, value: boolean) => {
      this.setState({
        EnableAllCreativeScanForEleaAI: EBool.fromBool(value),
      });
    };

    renderEnableOpenPath() {
      const checked = this.state.OpenPathEnabled ? EBool.toBool(this.state.OpenPathEnabled) : false;
      return (
        <Grid>
          <ModelSwitchView
            checked={checked}
            model={this.state}
            onChange={this.updateOpenPathEnabled}
          />
          Enable Open Path *
        </Grid>
      );
    }

    updateOpenPathEnabled = (_: any, value: boolean) => {
      this.setState({
        OpenPathEnabled: EBool.fromBool(value),
      });
    };

    renderEnableSSAI() {
      const checked = this.state.NetworkEnabled ? EBool.toBool(this.state.NetworkEnabled) : false;
      return (
        <Row noPadding>
          <Cols style={{ alignItems: 'center' }}>
            <Col>
              <ModelSwitchView
                checked={checked}
                model={this.state}
                onChange={this.updateEnableSSAI}
              />
            </Col>
            <Col>
              <Text>Enable Networks for Server-Side Ad Insertion *</Text>
            </Col>
          </Cols>
        </Row>
      );
    }

    renderEnableNativeVast() {
      const checked = this.state.NativeVastEnabled
        ? EBool.toBool(this.state.NativeVastEnabled)
        : false;
      return (
        <Row noPadding>
          <Cols style={{ alignItems: 'center' }}>
            <Col>
              <ModelSwitchView
                checked={checked}
                model={this.state}
                onChange={this.updateEnableNativeVast}
              />
            </Col>
            <Col>
              <Text>Enable Native Vast for LG Native Ad Support *</Text>
            </Col>
          </Cols>
        </Row>
      );
    }

    renderEnableGoogleSSL() {
      const checked = this.state.EnableGoogleAdxSSLCert
        ? EBool.toBool(this.state.EnableGoogleAdxSSLCert)
        : false;
      return (
        <Grid>
          <ModelSwitchView
            checked={checked}
            model={this.state}
            onChange={this.updateEnableGoogleSSL}
          />
          Enable Google ADX SSL Certification *
        </Grid>
      );
    }

    renderSmartFloorsEnabled() {
      const checked = this.state.SmartFloorsEnabled
        ? EBool.toBool(this.state.SmartFloorsEnabled)
        : false;
      return (
        <Grid>
          <ModelSwitchView
            checked={checked}
            model={this.state}
            onChange={this.updateSmartFloorsEnabled}
          />
          Enable Smart Floors on Bidders *
        </Grid>
      );
    }

    renderEnableOtherCurrency() {
      const checked = this.state.EnableOtherCurrency
        ? EBool.toBool(this.state.EnableOtherCurrency)
        : false;
      return (
        <Grid>
          <ModelSwitchView
            checked={checked}
            model={this.state}
            onChange={(_: any, value: boolean) => {
              this.setState({
                EnableOtherCurrency: EBool.fromBool(value),
              });
            }}
          />
          Support Other Currencies *
        </Grid>
      );
    }

    renderEnableAPSDemand() {
      const checked = this.state.EnableAPSDemand ? EBool.toBool(this.state.EnableAPSDemand) : false;
      return (
        <Grid>
          <ModelSwitchView
            checked={checked}
            model={this.state}
            onChange={(_: any, value: boolean) => {
              this.setState({
                EnableAPSDemand: EBool.fromBool(value),
              });
            }}
          />
          Enable APS Demand *
        </Grid>
      );
    }

    renderDisableCreativeBlocking() {
      const checked = this.state.DisableCreativeBlocking
        ? EBool.toBool(this.state.DisableCreativeBlocking)
        : false;
      return (
        <Grid>
          <ModelSwitchView
            checked={checked}
            model={this.state}
            onChange={this.updateDisableCreativeBlocking}
          />
          Disable Creative Blocking by API
        </Grid>
      );
    }

    renderEnableMRMDataEnrichment() {
      const MRMEnrichmentEnabled = [
        MRMEnrichmentMode.MRM_ENRICHMENT_MODE_STANDARD,
        MRMEnrichmentMode.MRM_ENRICHMENT_MODE_LABELING,
        MRMEnrichmentMode.MRM_ENRICHMENT_MODE_DECISIONING,
      ].includes(this.state.MRMEnrichmentMode);

      return (
        <>
          <Grid>
            <ModelSwitchView
              checked={MRMEnrichmentEnabled}
              model={this.state}
              onChange={(_: unknown, value: boolean) => {
                this.setState({
                  MRMEnrichmentMode: value
                    ? MRMEnrichmentMode.MRM_ENRICHMENT_MODE_STANDARD
                    : MRMEnrichmentMode.MRM_ENRICHMENT_MODE_DISABLED,
                  EnableMRMLabeling: value,
                  EnableMRMDecisioning: value,
                });
              }}
            />
            {ct('EnableMRMDataEnrichmentWithAsterisk')}
          </Grid>

          {MRMEnrichmentEnabled && (
            <Div style={{ paddingLeft: spacing.extraLarge }}>
              <Grid>
                <ModelSwitchView
                  checked={this.state.EnableMRMLabeling}
                  model={this.state}
                  onChange={(_: unknown, value: boolean) => {
                    this.setState({
                      EnableMRMLabeling: value,
                      MRMEnrichmentMode: getMRMEnrichmentMode(
                        value,
                        this.state.EnableMRMDecisioning,
                      ),
                    });
                  }}
                />
                {ct('EnableMRMDataEnrichmentLabeling')}
              </Grid>
              <Grid>
                <ModelSwitchView
                  checked={this.state.EnableMRMDecisioning}
                  model={this.state}
                  onChange={(_: unknown, value: boolean) => {
                    this.setState({
                      EnableMRMDecisioning: value,
                      MRMEnrichmentMode: getMRMEnrichmentMode(this.state.EnableMRMLabeling, value),
                    });
                  }}
                />
                {ct('EnableMRMDataEnrichmentDecisioning')}
              </Grid>
            </Div>
          )}
        </>
      );
    }

    renderManageFraudDetection(): JSX.Element {
      const checked = this.state.EnableIASIVTBlocklist
        ? EBool.toBool(this.state.EnableIASIVTBlocklist)
        : false;
      return (
        <Grid>
          <ModelSwitchView
            checked={checked}
            model={this.state}
            onChange={(_: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
              this.setState({
                EnableIASIVTBlocklist: EBool.fromBool(value),
              });
            }}
          />
          {ct('AllowPublisherToAccessAndManageFraudDetectionWithAsterisk')}
        </Grid>
      );
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updateEnableTrafficShaping = (_: any, value: boolean): void => {
      this.setState({
        EnableTrafficShaping: EBool.fromBool(value),
      });
    };

    patchTrafficShaping = (done: (err?: Error) => void): void => {
      patchPublisherTrafficShaping(this.props.session.publisher.ID, {
        EnableTrafficShaping: this.state.EnableTrafficShaping,
      })
        .then((res) => {
          if (res.success) {
            this.setState({
              snackbarMessage: res.msg || 'Successfully updated traffic optimization.',
              snackbarError: false,
              snackbarWarning: false,
              EnableTrafficShaping: res?.EnableTrafficShaping || this.state.EnableTrafficShaping,
            });
            this.props.dispatch(
              SESSION_ACTIONS_SET({
                publisher: {
                  ...this.props.session.publisher,
                  EnableTrafficShaping:
                    res?.EnableTrafficShaping || this.state.EnableTrafficShaping,
                },
              }),
            );
          } else {
            this.setState({
              snackbarMessage:
                res.msg || 'Failed to update traffic optimization. Please wait and try again.',
              snackbarError: true,
              snackbarWarning: false,
            });
          }
          done();
          return;
        })
        .catch((err) => {
          console.error(err);
          this.setState({
            snackbarMessage: 'Failed to update traffic optimization. Please wait and try again.',
            snackbarError: true,
            snackbarWarning: false,
          });
          done();
          return;
        });
    };

    renderEnableTrafficShaping(): JSX.Element {
      const checked = this.state.EnableTrafficShaping
        ? EBool.toBool(this.state.EnableTrafficShaping)
        : false;
      return (
        <Paper
          classes={{
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            root: this.props.classes.paper,
          }}
        >
          <Typography variant='h6' gutterBottom>
            Traffic Optimization *
          </Typography>
          <Grid>
            <ModelSwitchView
              checked={checked}
              model={this.state}
              onChange={this.updateEnableTrafficShaping}
            />
            Enable Traffic Optimization
          </Grid>
          <div style={{ marginTop: '2rem' }}>
            <AsyncButtonOldV2
              text='Save'
              onClick={this.handleAsyncButtonClick('updateTrafficShaping')}
            />
          </div>
        </Paper>
      );
    }

    updateAdQualityTools = (): void => {
      updatePublisher({
        query: {
          publisher: {
            ID: this.props.session.publisher.ID,
            AllowPublisherToEnableEleaAI: this.state.AllowPublisherToEnableEleaAI,
            PremiumFeaturesSelectionEleaAI: this.state.PremiumFeaturesSelectionEleaAI,
            EnableAllCreativeScanForEleaAI: this.state.EnableAllCreativeScanForEleaAI,
          },
        },
      })
        .then((resp: { publisher: IPublisher }) => {
          this.setState({
            snackbarMessage: ct('SnackbarSuccessfullyUpdatedItem', {
              item: ct('AdQualityTools'),
            }),
            snackbarError: false,
            snackbarWarning: false,
            adQualityToolsModalActive: false,
            AllowPublisherToEnableEleaAI: resp.publisher.AllowPublisherToEnableEleaAI,
            PremiumFeaturesSelectionEleaAI: resp.publisher.PremiumFeaturesSelectionEleaAI,
            EnableAllCreativeScanForEleaAI: resp.publisher.EnableAllCreativeScanForEleaAI,
          });
          this.props.dispatch(
            SESSION_ACTIONS_SET({
              publisher: resp.publisher,
            }),
          );
        })
        .catch(() => {
          this.setState({
            adQualityToolsModalActive: false,
            snackbarMessage: ct('SnackbarFailedToUpdateItem', {
              item: ct('AdQualityTools'),
            }),
            snackbarError: true,
            snackbarWarning: false,
          });
        });
    };

    renderEnableAdQualityTools(): JSX.Element {
      return (
        <Paper
          classes={{
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            root: this.props.classes.paper,
          }}
        >
          <Grid container style={{ marginBottom: '0.35em' }}>
            <Text bold style={{ fontSize: '20px' }} tKey='AdQualityToolsWithAsterisk' />
          </Grid>
          <Grid container style={{ marginBottom: '0.35em' }}>
            <Text small tKey='TooltipAdQualityToolsManageFeatureAccess' />
            <br />
            <br />
            <Text small bold tKey='TooltipAdQualityToolsDescriptionWarning' />
          </Grid>
          <Grid>
            {this.renderAllowPublisherToEnableEleaAI()}
            {this.renderEnableAllCreativeScanForEleaAI()}
          </Grid>
          <div style={{ marginTop: '2rem' }}>
            <AsyncButtonOldV2
              text='Save'
              onClick={(done) => {
                this.setState({
                  adQualityToolsModalActive: true,
                });
                done();
              }}
            />
          </div>
        </Paper>
      );
    }

    // Called EnableBulkAPIS in the backend and DB
    renderEnableBatchAPIs() {
      const checked = this.state.EnableBulkAPIs ? EBool.toBool(this.state.EnableBulkAPIs) : false;
      return (
        <Grid>
          <ModelSwitchView
            checked={checked}
            model={this.state}
            onChange={(_: any, value: boolean) => {
              this.setState({
                EnableBulkAPIs: EBool.fromBool(value),
              });
            }}
          />
          Enable Batch APIs *
        </Grid>
      );
    }

    // Calls EnablePublicaVault in the backend and DB
    renderEnablePublicaVaultAPIs(): JSX.Element {
      const checked = this.state.EnablePublicaVault
        ? EBool.toBool(this.state.EnablePublicaVault)
        : false;
      return (
        <Grid>
          <ModelSwitchView
            checked={checked}
            model={this.state}
            onChange={(_, value: boolean) => {
              this.setState({
                EnablePublicaVault: EBool.fromBool(value),
              });
            }}
          />
          Allow Publisher to Update Publica Vault *
        </Grid>
      );
    }

    renderIsResellerPublisher(): JSX.Element {
      const checked = this.state.IsResellerPublisher
        ? EBool.toBool(this.state.IsResellerPublisher)
        : false;
      return (
        <Grid>
          <ModelSwitchView
            checked={checked}
            model={this.state}
            onChange={(_, value: boolean) => {
              this.setState({
                IsResellerPublisher: EBool.fromBool(value),
              });
            }}
          />
          Is Reseller/Network Publisher *
        </Grid>
      );
    }

    renderEnableSponsorshipMode(): JSX.Element {
      const checked = this.state.EnableSponsorshipMode
        ? EBool.toBool(this.state.EnableSponsorshipMode)
        : false;
      return (
        <Grid>
          <ModelSwitchView
            checked={checked}
            model={this.state}
            onChange={this.updateEnableSponsorshipMode}
          />
          Enables Sponsorship Mode for Bidders *
        </Grid>
      );
    }

    updateEnableSponsorshipMode = (_: unknown, value: boolean): void => {
      this.setState({
        EnableSponsorshipMode: EBool.fromBool(value),
      });
    };

    updateDisableCreativeBlocking = (_: unknown, value: boolean): void => {
      this.setState({
        DisableCreativeBlocking: EBool.fromBool(value),
      });
    };

    renderEnableAPSDedup() {
      const checked = this.state.EnableAPSDedup ? EBool.toBool(this.state.EnableAPSDedup) : false;
      return (
        <Grid>
          <ModelSwitchView
            checked={checked}
            model={this.state}
            onChange={this.updateEnableAPSDedup}
          />
          Enforce Unique APS keys (vast) *
        </Grid>
      );
    }

    updateEnableAPSDedup = (_: any, value: boolean) => {
      this.setState({
        EnableAPSDedup: EBool.fromBool(value),
      });
    };

    updateEnableSSAI = (_: any, value: boolean) => {
      this.setState({
        NetworkEnabled: EBool.fromBool(value),
      });
    };

    updateEnableNativeVast = (_: any, value: boolean) => {
      this.setState({
        NativeVastEnabled: EBool.fromBool(value),
      });
    };

    updateEnableGoogleSSL = (_: any, value: boolean) => {
      this.setState({
        EnableGoogleAdxSSLCert: EBool.fromBool(value),
      });
    };

    updateSmartFloorsEnabled = (_: any, value: boolean) => {
      this.setState({
        SmartFloorsEnabled: EBool.fromBool(value),
      });
    };

    updatePublisher = (done: (err?: Error) => void) => {
      const errors = this.validateForm();
      if (errors !== '') {
        this.setState({
          snackbarMessage:
            'Updating Publisher Settings failed. Please fix the errors and try again.\n' + errors,
          snackbarError: true,
          snackbarWarning: false,
        });
        done();
        return;
      }
      const CurrencyDisplayed = convertStringToECurrencyType(this.state.CurrencyDisplayed);
      updatePublisher({
        query: {
          publisher: Object.assign(
            Object.assign(
              {
                ID: this.props.session.publisher.ID,
                Name: this.state.Name,
                Domain: this.state.Domain,
                Timezone: this.state.Timezone,
                NativeVastEnabled: this.state.NativeVastEnabled,
                NetworkEnabled: this.state.NetworkEnabled,
                EnableIASDataSharing: this.state.EnableIASDataSharing,
                IASDataSharing: this.state.IASDataSharing,
                EnableDoubleVerifyDataSharing: this.state.EnableDoubleVerifyDataSharing,
                DoubleVerifyDataSharing: this.state.DoubleVerifyDataSharing,
                ExcludedReportingDimensions: this.state.ExcludedReportingDimensions,
                DDMonitoring: this.state.DDMonitoring,
                AllowPublisherIrisAltContentID: this.state.AllowPublisherIrisAltContentID,
                CurrencyDisplayed,
                PublisherDevelopmentManager: this.state.PublisherDevelopmentManager,
                SupportTier: this.state.SupportTier,
                SolutionsArchitect: this.state.SolutionsArchitect,
                EnableIASFirstPartyVASTTracking: this.state.EnableIASFirstPartyVASTTracking,
                IASAnID: this.state.IASAnID,
                EnableIASThirdPartyVASTTracking: this.state.EnableIASThirdPartyVASTTracking,
                ContextualSegmentEnabled: this.state.ContextualSegmentEnabled,
                IrisClientToken: this.state.IrisClientToken,
                IrisContextualSegmentsEnabled: this.state.IrisContextualSegmentsEnabled,
                IASContextualSegmentsEnabled: this.state.IASContextualSegmentsEnabled,
                ComscoreContextualSegmentsEnabled: this.state.ComscoreContextualSegmentsEnabled,
                EnableExtendedRewrites: this.state.EnableExtendedRewrites,
                EnablePlatformMarketplace: this.state.EnablePlatformMarketplace,
                PublisherType: this.state.PublisherType,
                LogSamplingEnabled: this.state.LogSamplingEnabled,
                OpenPathEnabled: this.state.OpenPathEnabled,
                EnableGoogleAdxSSLCert: this.state.EnableGoogleAdxSSLCert,
                DisableCreativeBlocking: this.state.DisableCreativeBlocking,
                EnableAPSDedup: this.state.EnableAPSDedup,
                EnableAPSDemand: this.state.EnableAPSDemand,
                EnableBulkAPIs: this.state.EnableBulkAPIs,
                EnablePublicaVault: this.state.EnablePublicaVault,
                IsResellerPublisher: this.state.IsResellerPublisher,
                SmartFloorsEnabled: this.state.SmartFloorsEnabled,
                EnableOtherCurrency: this.state.EnableOtherCurrency,
                EnableSponsorshipMode: this.state.EnableSponsorshipMode,
                MRMEnrichmentMode: this.state.MRMEnrichmentMode,
                EnableIASIVTBlocklist: this.state.EnableIASIVTBlocklist,
              },
              hasRoleSuperUser(this.props.user.user) && !!this.state.Reseller.ID
                ? {
                    ResellerID: this.state.Reseller.ID,
                  }
                : {},
            ),
            isRoku()
              ? {
                  RokuSeatIDStr: this.state.RokuSeatID,
                }
              : {},
          ),
        },
      })
        .then((resp: any) => {
          this.setState({
            snackbarMessage: 'Successfully updated publisher.',
            snackbarError: false,
            snackbarWarning: false,
            ...resp.publisher,
          });
          this.props.dispatch(
            SESSION_ACTIONS_SET({
              publisher: resp.publisher,
            }),
          );
          done();
        })
        .catch(() => {
          this.setState(
            {
              snackbarMessage: 'Updating publisher failed. Please try again later.',
              snackbarError: true,
              snackbarWarning: false,
            },
            done,
          );
        });
    };

    updatePublisherLocalization = (done: (err?: Error) => void) => {
      updatePublisher({
        query: {
          publisher: {
            ID: this.props.session.publisher.ID,
            LocalizationID: this.state.localizationID,
          },
        },
      })
        .then((resp: any) => {
          this.setState({
            snackbarMessage: 'Successfully updated publisher.',
            snackbarError: false,
            snackbarWarning: false,
            ...resp.publisher,
          });
          this.props.dispatch(
            SESSION_ACTIONS_SET({
              publisher: resp.publisher,
            }),
          );
          done();
        })
        .catch(() => {
          this.setState(
            {
              snackbarMessage: 'Updating publisher failed. Please try again later.',
              snackbarError: true,
              snackbarWarning: false,
            },
            done,
          );
        });
    };

    updateDefaultPublicaVaultConfig = (done: (err?: Error) => void): void => {
      if (
        this.state.DefaultPublicaVaultConfig.StoreBelowFloorBids === true &&
        this.state.DefaultPublicaVaultConfig.MaxUnderFloorValue !== undefined
      ) {
        // MaxUnderFloorValue should never be negative
        if (this.state.DefaultPublicaVaultConfig.MaxUnderFloorValue < 0) {
          this.setState({
            snackbarMessage: MaxUnderFloorError.Zero,
            snackbarError: true,
            snackbarWarning: false,
          });
          done();
          return;
        }
        if (this.state.DefaultPublicaVaultConfig.MaxUnderFloorType === MaxUnderFloorType.Percent) {
          if (this.state.DefaultPublicaVaultConfig.MaxUnderFloorValue > 50) {
            this.setState({
              snackbarMessage: MaxUnderFloorError.Fifty,
              snackbarError: true,
              snackbarWarning: false,
            });
            done();
            return;
          }
        }
      }
      updatePublisher({
        query: {
          publisher: {
            ID: this.props.session.publisher.ID,
            DefaultPublicaVaultConfig: this.state.DefaultPublicaVaultConfig,
          },
        },
      })
        // eslint-disable-next-line
        .then((resp: any) => {
          // eslint-disable-next-line
          this.setState({
            snackbarMessage: 'Successfully updated publisher.',
            snackbarError: false,
            snackbarWarning: false,
            // eslint-disable-next-line
            ...resp.publisher,
          });
          this.props.dispatch(
            SESSION_ACTIONS_SET({
              // eslint-disable-next-line
              publisher: resp.publisher,
            }),
          );
          done();
        })
        .catch(() => {
          this.setState(
            {
              snackbarMessage: 'Updating publisher failed. Please try again later.',
              snackbarError: true,
              snackbarWarning: false,
            },
            done,
          );
        });
    };

    updateIASIVTBlocklist = (done: (err?: Error) => void): void => {
      if (
        this.state.EnableIASIVTBlocklist === EBool.EBool_TRUE &&
        this.state.IASIVTBlocklistTargetingHeaderbidder === EBool.EBool_TRUE &&
        this.state.IASIVTBlocklistSelectedBidderIDs.length === 0
      ) {
        this.setState({
          snackbarMessage: ct('ErrorPleaseSelectBiddersManageFraudDetection'),
          snackbarError: true,
          snackbarWarning: false,
        });
        done();
        return;
      }

      updatePublisher({
        query: {
          publisher: {
            ID: this.props.session.publisher.ID,
            IASIVTBlocklistTargetingAllInventory: this.state.IASIVTBlocklistTargetingAllInventory,
            IASIVTBlocklistTargetingHeaderbidder: this.state.IASIVTBlocklistTargetingHeaderbidder,
            IASIVTBlocklistSelectedBidderIDs: this.state.IASIVTBlocklistSelectedBidderIDs,
          },
        },
      })
        .then(({ publisher }: IPublisher) => {
          this.setState({
            snackbarMessage: ct('SnackbarSuccessfullyUpdatedItem', { item: ct('Publisher') }),
            snackbarError: false,
            snackbarWarning: false,
            ...publisher,
          });
          this.props.dispatch(
            SESSION_ACTIONS_SET({
              // eslint-disable-next-line
              publisher: publisher,
            }),
          );
          done();
        })
        .catch(() => {
          this.setState(
            {
              snackbarMessage: ct('SnackbarFailedToUpdateItem', { item: ct('Publisher') }),
              snackbarError: true,
              snackbarWarning: false,
            },
            done,
          );
        });
    };

    updatePublisherAccessKeys = (done: (err?: Error) => void) => {
      updatePublisher({
        query: {
          publisher: {
            ID: this.props.session.publisher.ID,
            PublisherAccessKey: this.state.publisherAccessKey,
            PublisherSecretKey: this.state.publisherSecretKey,
          },
        },
      })
        .then((resp: any) => {
          this.setState({
            snackbarMessage: 'Successfully updated publisher.',
            snackbarError: false,
            snackbarWarning: false,
            ...resp.publisher,
          });
          this.props.dispatch(
            SESSION_ACTIONS_SET({
              publisher: resp.publisher,
            }),
          );
          done();
        })
        .catch(() => {
          this.setState(
            {
              snackbarMessage: 'Updating publisher failed. Please try again later.',
              snackbarError: true,
              snackbarWarning: false,
            },
            done,
          );
        });
    };

    updateBidderTier = (done: (err?: Error) => void) => {
      updatePublisher({
        query: {
          publisher: {
            ID: this.props.session.publisher.ID,
            BidderTier1CustomName: this.state.BidderTier1CustomName,
            BidderTier2CustomName: this.state.BidderTier2CustomName,
            BidderTier3CustomName: this.state.BidderTier3CustomName,
            BidderTier4CustomName: this.state.BidderTier4CustomName,
            BidderTier5CustomName: this.state.BidderTier5CustomName,
            BidderTier6CustomName: this.state.BidderTier6CustomName,
            BidderTier7CustomName: this.state.BidderTier7CustomName,
            BidderTier8CustomName: this.state.BidderTier8CustomName,
            BidderTier9CustomName: this.state.BidderTier9CustomName,
            BidderTier10CustomName: this.state.BidderTier10CustomName,
          },
        },
      })
        .then((resp: any) => {
          this.setState({
            snackbarMessage: 'Successfully updated publisher.',
            snackbarError: false,
            snackbarWarning: false,
            ...resp.publisher,
          });
          this.props.dispatch(
            SESSION_ACTIONS_SET({
              publisher: resp.publisher,
            }),
          );
          done();
        })
        .catch(() => {
          this.setState(
            {
              snackbarMessage: 'Updating publisher failed. Please try again later.',
              snackbarError: true,
              snackbarWarning: false,
            },
            done,
          );
        });
    };

    updatePublisherAPIToken = (done: (err?: Error) => void) => {
      updatePublisherAPIToken(
        this.props.session.publisher.ID,
        this.props.user.user.PermissionRole.permissions,
      )
        .then((token: string) => {
          done();
          this.setState({
            publisherAPIToken: token,
          });
        })
        .catch((err) => {
          console.error(err);
          this.setState(
            {
              snackbarMessage: 'Updating publisher api token failed.',
              snackbarError: true,
              snackbarWarning: false,
            },
            () => done(err),
          );
        });
    };

    updateFreeTrial = (done: (err?: Error) => void) => {
      if (hasRoleSuperUser(this.props.user.user)) {
        updatePublisher({
          query: {
            publisher: Object.assign(
              {
                ID: this.props.session.publisher.ID,
                FreeTrialActive: this.state.FreeTrialActive,
                // only update free trial dates if free trial is enabled
              },
              this.state.FreeTrialActive === '2'
                ? {
                    FreeTrialStartDate: formatDateWithOffsetToUTC(
                      this.state.FreeTrialStartDate,
                      this.state.Timezone,
                    ),
                    FreeTrialEndDate: formatDateWithOffsetToUTC(
                      this.state.FreeTrialEndDate,
                      this.state.Timezone,
                    ),
                  }
                : {},
            ),
          },
        })
          .then((resp: any) => {
            // check for null dates coming from DB
            const newState = Object.assign({}, { ...resp.publisher });
            if (newState.FreeTrialStartDate === 'null') {
              const defaultTrialStartDate = new Date().toLocaleString('en-US');
              newState.FreeTrialStartDate = defaultTrialStartDate;
            } else {
              newState.FreeTrialStartDate = formatDateFromUTCToOffset(
                newState.FreeTrialStartDate,
                this.props.session.publisher.Timezone,
              );
            }

            if (newState.FreeTrialEndDate === 'null') {
              const twoWeeks = 1000 * 60 * 60 * 24 * 14;
              const twoWeeksTime = new Date(new Date().getTime() + twoWeeks);
              const defaultTrialEndDate = twoWeeksTime.toLocaleString('en-US');
              newState.FreeTrialEndDate = defaultTrialEndDate;
            } else {
              newState.FreeTrialEndDate = formatDateFromUTCToOffset(
                newState.FreeTrialEndDate,
                this.props.session.publisher.Timezone,
              );
            }
            this.setState({
              ...newState,
            });
            this.props.dispatch(
              SESSION_ACTIONS_SET({
                publisher: resp.publisher,
              }),
            );
            done();
          })
          .catch(() => {
            this.setState({
              snackbarError: true,
              snackbarMessage: 'Error updating free trial',
            });
          });
      }
    };

    updateLoginMethod = (done: (err?: Error) => void) => {
      const enabledSAMLIdentityProvider = this.state.SAMLIdentityProvidersList.filter(
        (SAMLIdProvider) => {
          return (
            SAMLIdProvider.Enabled === EBool.EBool_TRUE &&
            SAMLIdProvider.ID !== this.state.deleteSAMLIdentityProvider.ID
          );
        },
      );

      const allUpdateSAML = [] as Array<Promise<unknown>>;
      this.state.SAMLIdentityProvidersList.forEach((SAMLIdProvider) => {
        allUpdateSAML.push(
          updateSAMLIdentityProviderEnabledOnly({
            query: {
              samlID: SAMLIdProvider.ID,
            },
            body: {
              enabled: SAMLIdProvider.Enabled,
            },
          }),
        );
      });
      Promise.all([
        updatePublisher({
          query: {
            publisher: {
              ID: this.props.session.publisher.ID,
              EnableDirectLogin:
                enabledSAMLIdentityProvider.length === 0
                  ? EBool.EBool_TRUE
                  : this.state.EnableDirectLogin,
            },
          },
        }),
        ...allUpdateSAML,
      ])
        .then((resp: any) => {
          this.setState({
            EnableDirectLogin: resp[0].publisher.EnableDirectLogin,
            snackbarMessage: 'Successfully Updated Login Method.',
            snackbarError: false,
            snackbarWarning: false,
          });
          this.props.dispatch(
            SESSION_ACTIONS_SET({
              publisher: resp[0].publisher,
            }),
          );
          done();
        })
        .catch(() => {
          this.setState(
            {
              snackbarMessage: 'Updating Login Method failed. Please try again later.',
              snackbarError: true,
              snackbarWarning: false,
            },
            done,
          );
        });
    };

    createLoginMethod = () => {
      createSAMLIdentityProvider({
        query: {
          publisherID: this.props.user.publisher.ID,
          displayName: 'Update Required',
          identityProviderSSOURL: ' ',
          identityProviderIssuer: ' ',
          certificate: ' ',
          autoprovision: EBool.EBool_FALSE,
          permissionsRoleID: 17,
          uuid: uuid(),
          enabled: EBool.EBool_FALSE,
          resellerTitle: getResellerTitle(),
        },
      })
        .then(() => {
          this.setState({
            snackbarMessage:
              'Successfully added a New Login Method. \n Please update it with the correct information after creation of \n the SAML app for Publica with your Single Sign-On platform',
            snackbarError: false,
            snackbarWarning: false,
            openSAMLIntegrationModal: SAMLIntegrationModal.CLOSE,
            SAMLDisplayName: '',
            SAMLIdentityProviderSSOURL: '',
            SAMLIdentityProviderIssuer: '',
            SAMLCertificate: '',
            SAMLAutoprovision: EBool.EBool_FALSE,
            SAMLPermissionsRoleID: 0,
            SAMLUUID: '',
          });
          this.getSAMLIdentityProvider();
        })
        .catch((err) => {
          this.setState({
            snackbarMessage: `${err}. Please try again later.`,
            snackbarError: true,
            snackbarWarning: false,
          });
        });
    };

    updateSAMLIdentityProvider = (done: (err?: Error) => void) => {
      const cleanCertificate = this.state.SAMLCertificate.replace('-----BEGIN CERTIFICATE-----', '')
        .replace('-----END CERTIFICATE-----', '')
        .replace(/\n+\n/g, '\n')
        .replace(/^\n/g, '')
        .replace(/\n$/g, '');
      updateSAMLIdentityProvider({
        query: {
          samlID: this.state.updateSAMLID,
        },
        body: {
          displayName: this.state.SAMLDisplayName,
          identityProviderSSOURL: this.state.SAMLIdentityProviderSSOURL,
          identityProviderIssuer: this.state.SAMLIdentityProviderIssuer,
          certificate: cleanCertificate,
          autoprovision: this.state.SAMLAutoprovision,
          permissionsRoleID: this.state.SAMLPermissionsRoleID,
        },
      })
        .then(() => {
          this.setState({
            snackbarMessage: 'Successfully updated the Login Method.',
            snackbarError: false,
            snackbarWarning: false,
            openSAMLIntegrationModal: SAMLIntegrationModal.CLOSE,
            SAMLDisplayName: '',
            SAMLIdentityProviderSSOURL: '',
            SAMLIdentityProviderIssuer: '',
            SAMLCertificate: '',
            SAMLAutoprovision: EBool.EBool_FALSE,
            SAMLPermissionsRoleID: 0,
            updateSAMLID: 0,
            SAMLUUID: '',
          });
          this.getSAMLIdentityProvider();
          done();
        })
        .catch((e) => {
          this.setState(
            {
              snackbarMessage: Error(e)
                ? Error(e).message
                : 'Updating the Login Method failed. Please try again later.',
              snackbarError: true,
              snackbarWarning: false,
            },
            done,
          );
        });
    };

    createDealDemandPartner = (done: (err?: Error) => void) => {
      createDealDemandPartner(this.state.dealDemandPartnerName).then(([dealDemandPartner, err]) => {
        if (err || !dealDemandPartner) {
          this.setState(
            {
              snackbarMessage: `${err}. Please try again later.`,
              snackbarError: true,
              snackbarWarning: false,
              dealDemandPartnerName: '',
            },
            done,
          );
        } else {
          this.setState({
            snackbarMessage: 'Successfully added a New Deal Demand Partner.',
            snackbarError: false,
            snackbarWarning: false,
            openCreateDealDemandPartnerModal: false,
            dealDemandPartnerName: '',
          });
          this.getDealDemandPartners();
          done();
        }
      });
    };

    snackbarClose = () => {
      this.setState({
        snackbarMessage: '',
        snackbarError: false,
        snackbarWarning: false,
      });
    };

    toggleShowToken = () => {
      this.setState({ showToken: !this.state.showToken });
    };

    handleAsyncButtonClick = (
      type:
        | 'updatePublisherAPIToken'
        | 'updatePublisher'
        | 'updateTrafficShaping'
        | 'updateFreeTrial'
        | 'updateLocalization'
        | 'updateAudiencePixelDrop'
        | 'updateAudienceDataShare'
        | 'updateAudienceDataStore'
        | 'updateBidderTier'
        | 'deleteLoginMethod'
        | 'updateLoginMethod'
        | 'updateSAMLIdentityProvider'
        | 'updatePublisherAccessKeys'
        | 'updateS3AccessPointTTD'
        | 'updateS3AccessPointGeneral'
        | 'createDealDemandPartner'
        | 'updateDefaultPublicaVaultConfig'
        | 'updateIASIVTBlocklist',
    ) => {
      if (type === 'updatePublisherAPIToken') {
        return (done: () => void) => {
          this.updatePublisherAPIToken(() => {
            done();
          });
        };
      } else if (type === 'updatePublisher') {
        return (done: () => void) => {
          this.updatePublisher(() => {
            done();
          });
        };
      } else if (type === 'updateTrafficShaping') {
        return (done: () => void) => {
          this.patchTrafficShaping(() => {
            done();
          });
        };
      } else if (type === 'updateLocalization') {
        return (done: () => void) => {
          this.updatePublisherLocalization(() => {
            done();
          });
        };
      } else if (type === 'updateBidderTier') {
        return (done: () => void) => {
          this.updateBidderTier(() => {
            done();
          });
        };
      } else if (type === 'updateLoginMethod') {
        return (done: () => void) => {
          this.updateLoginMethod(() => {
            done();
          });
        };
      } else if (type === 'updateSAMLIdentityProvider') {
        return (done: () => void) => {
          this.updateSAMLIdentityProvider(() => {
            done();
          });
        };
      } else if (type === 'createDealDemandPartner') {
        return (done: () => void) => {
          this.createDealDemandPartner(() => {
            done();
          });
        };
      } else if (type === 'updatePublisherAccessKeys') {
        return (done: () => void) => {
          this.updatePublisherAccessKeys(() => {
            done();
          });
        };
      } else if (type === 'updateS3AccessPointTTD') {
        return (done: () => void) => {
          this.createOrUpdateS3AccessPoint(done)(EBool.EBool_TRUE);
        };
      } else if (type === 'updateS3AccessPointGeneral') {
        return (done: () => void) => {
          this.createOrUpdateS3AccessPoint(done)(EBool.EBool_FALSE);
        };
      } else if (type === 'updateDefaultPublicaVaultConfig') {
        return (done: () => void) => {
          this.updateDefaultPublicaVaultConfig(() => {
            done();
          });
        };
      } else if (type === 'updateIASIVTBlocklist') {
        return (done: () => void) => {
          this.updateIASIVTBlocklist(() => {
            done();
          });
        };
      } else {
        return (done: () => void) => {
          this.updateFreeTrial(() => {
            done();
          });
        };
      }
    };

    handleModalCancelClick = (): void => {
      this.setState({
        modalActive: false,
        toActivateModalNames: '',
        toDeactivateModalNames: '',
      });
    };

    // opens the modal to confirm switching active status of pubs
    handlePublishersAcceptClick = (list: IMenuList): void => {
      const publishersToDeactivate = [] as string[];
      const publishersToActivate = [] as string[];
      for (const item of Object.values(list)) {
        if (item.selected && !item.originalValueSelected) {
          publishersToActivate.push(item.title);
        }
        if (!item.selected && item.originalValueSelected) {
          publishersToDeactivate.push(item.title);
        }
      }
      if (publishersToActivate.length || publishersToDeactivate.length) {
        this.setState({
          modalActive: true,
          toActivateModalNames: publishersToActivate.join(', '),
          toDeactivateModalNames: publishersToDeactivate.join(', '),
        });
      }
    };

    // activates / deactivates pubs via api
    handleModalAcceptClick = (): void => {
      const publishersToDeactivate = [] as number[];
      const publishersToActivate = [] as number[];
      const list = this.state.publishersList;
      for (const item of Object.values(list)) {
        if (item.selected && !item.originalValueSelected) {
          publishersToActivate.push(parseInt(item.ID, 10));
        }
        if (!item.selected && item.originalValueSelected) {
          publishersToDeactivate.push(parseInt(item.ID, 10));
        }
      }

      updatePublishersActive(publishersToDeactivate, publishersToActivate)
        .then((resp) => {
          if (resp.status === 200) {
            this.generatePublisherList();
            // add refresh query param to update the side bar
            window.location.href =
              '/#' +
              getRoutePath(RoutePublisherSettings, extractRouteParams(this.props), {
                publisherID: this.props.session.publisher.ID,
              }) +
              `?refresh=${this.state.refresh}`;
            this.setState({
              refresh: this.state.refresh + 1,
              modalActive: false,
              toActivateModalNames: '',
              toDeactivateModalNames: '',
            });
          } else {
            for (const item of Object.values(list)) {
              item.selected = !!item.originalValueSelected;
            }
            this.setState({
              snackbarError: true,
              snackbarWarning: false,
              snackbarMessage: `Error updating publishers' hidden status.`,
              modalActive: false,
              toActivateModalNames: '',
              toDeactivateModalNames: '',
            });
          }
        })
        .catch(() => {
          this.setState({
            snackbarError: true,
            snackbarWarning: false,
            snackbarMessage: `Error updating publishers' hidden status.`,
            modalActive: false,
            toActivateModalNames: '',
            toDeactivateModalNames: '',
          });
        });
    };

    isResellerParentPub = (id: string) => {
      return ['437', '475'].includes(id);
    };

    renderFreeTrialControls = () => {
      const { classes } = this.props;
      return (
        <Paper
          classes={{
            root: classes.paper,
          }}
        >
          <Typography variant='h6' gutterBottom>
            Update Free Trial *
          </Typography>
          <RenderForm
            schema={freeTrialForm}
            data={{
              FreeTrialActive: this.state.FreeTrialActive,
            }}
            onUpdate={this.onUpdateFreeTrial}
          />

          {this.state.FreeTrialActive === '2' && (
            <DateTimeRangeComponent
              timezone={this.state.Timezone}
              start={this.state.FreeTrialStartDate}
              end={this.state.FreeTrialEndDate}
              maxDateExtended={6}
              onChange={this.handleDateChange}
              disableTime={true}
              openDirection={'up'}
              enablePresets={true}
            />
          )}
          <div style={{ marginTop: '2rem' }}>
            <AsyncButtonOldV2
              text='Save'
              onClick={this.handleAsyncButtonClick('updateFreeTrial')}
            />
          </div>
        </Paper>
      );
    };

    renderActivateResellers = () => {
      const { classes } = this.props;
      return (
        <Paper
          classes={{
            root: classes.paper,
          }}
        >
          <Typography variant='h6' gutterBottom>
            Active Resellers
          </Typography>
          <Grid style={{ marginTop: 5 }}>
            <MaterialSearchDropdownMulti
              fontSize='16px'
              width='555px'
              menuTitle=''
              list={this.state.publishersList}
              onChange={(publishersList: IMenuList) => {
                this.setState({
                  publishersList,
                });
              }}
              handleMenuAcceptClick={(src: IMenuList) => {
                this.handlePublishersAcceptClick(src);
              }}
              selectAll={true}
            />
          </Grid>
        </Paper>
      );
    };

    renderSAMLIntegration = () => {
      const { openSAMLIntegrationModal } = this.state;

      let appName = 'GetPublica';
      let SSOURL = 'https://login.getpublica.com/v1/login/saml/';
      let audienceURI = 'https://app.getpublica.com';
      switch (getResellerTitle()) {
        case 'OTTera':
          appName = 'OTTera';
          audienceURI = 'https://app.ads.ottera.tv';
          SSOURL = 'https://login.ads.ottera.tv/v1/login/saml/';
          break;
        case 'Evrideo':
          appName = 'Evrideo';
          audienceURI = 'https://app.evrideo-ads.tv';
          SSOURL = 'https://login.evrideo-ads.tv/v1/login/saml/';
          break;
        case 'Philo':
          appName = 'Philo';
          audienceURI = 'https://app.ads.philo.com';
          SSOURL = 'https://login.ads.philo.com/v1/login/saml/';
          break;
        case 'Orka':
          appName = 'Orka';
          audienceURI = 'https://app.pacific.orka.biz';
          SSOURL = 'https://login.pacific.orka.biz/v1/login/saml/';
          break;
        case 'IAS Publisher':
          appName = 'IAS Publisher';
          audienceURI = 'https://app.publisher.integralplatform.com';
          SSOURL = 'https://login.publisher.integralplatform.com/v1/login/saml/';
          break;
      }
      SSOURL = SSOURL + this.state.SAMLUUID;

      return (
        <DialogWidth720
          maxWidth='md'
          keepMounted
          open={openSAMLIntegrationModal !== SAMLIntegrationModal.CLOSE}
          onClose={() => this.setState({ openSAMLIntegrationModal: SAMLIntegrationModal.CLOSE })}
        >
          <Grid item style={{ padding: '30px' }}>
            <Typography variant='h6' gutterBottom>
              Update SAML Integration
            </Typography>
            <Grid
              container
              direction='column'
              alignItems='flex-start'
              style={{ padding: '0 30px 10px 30px' }}
            >
              <Typography variant='subtitle2' color='textSecondary'>
                Please copy and paste the following information to create the SAML app for Publica
                with your Single Sign-On platform:
              </Typography>
              <Grid item style={{ width: '100%', padding: '5px 0 5px 0' }}>
                <Typography>App Name:</Typography>
                <Grid container direction='row' alignItems='center'>
                  <Grid item style={{ width: '85%' }}>
                    <TextField
                      disabled
                      name='app name'
                      fullWidth
                      variant='outlined'
                      value={appName}
                    />
                  </Grid>
                  <Grid item style={{ width: '10%', padding: '10px' }}>
                    <CopyButton copy={appName} text='Copy' />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item style={{ width: '100%', padding: '5px 0 5px 0' }}>
                <Typography>Single Sign-On URL:</Typography>
                <Grid container direction='row' alignItems='center'>
                  <Grid item style={{ width: '85%' }}>
                    <TextField disabled name='ssourl' fullWidth variant='outlined' value={SSOURL} />
                  </Grid>
                  <Grid item style={{ width: '10%', padding: '10px' }}>
                    <CopyButton copy={SSOURL} text='Copy' />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item style={{ width: '100%', padding: '5px 0 5px 0' }}>
                <Typography>Audience URI:</Typography>
                <Grid container direction='row' alignItems='center'>
                  <Grid item style={{ width: '85%' }}>
                    <TextField
                      disabled
                      name='audienceURI'
                      fullWidth
                      variant='outlined'
                      value={audienceURI}
                    />
                  </Grid>
                  <Grid item style={{ width: '10%', padding: '10px' }}>
                    <CopyButton copy={audienceURI} text='Copy' />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              direction='column'
              justify='flex-start'
              alignItems='flex-start'
              style={{ padding: '30px' }}
            >
              <Typography variant='subtitle2' color='textSecondary'>
                Once the SAML app for Publica is created, please edit the following fields, which
                are required to implement Single Sign-On via SAML for Publica.
              </Typography>
              <Grid item style={{ width: '100%' }}>
                <Typography>SAML Display Name</Typography>
                <TextField
                  name='SAMLDisplayName'
                  fullWidth
                  variant='outlined'
                  value={
                    this.state.SAMLDisplayName === 'Update Required'
                      ? ''
                      : this.state.SAMLDisplayName
                  }
                  onChange={this.handleSAMLInput}
                  style={{ padding: '10px 0 10px 0' }}
                  placeholder='Please enter a display name'
                />
              </Grid>
              <Grid item style={{ width: '100%' }}>
                <Typography>Identity Provider Single Sign-On URL</Typography>
                <TextField
                  name='SAMLIdentityProviderSSOURL'
                  fullWidth
                  variant='outlined'
                  value={
                    this.state.SAMLIdentityProviderSSOURL === ' '
                      ? ''
                      : this.state.SAMLIdentityProviderSSOURL
                  }
                  onChange={this.handleSAMLInput}
                  style={{ padding: '10px 0 10px 0' }}
                  placeholder="Please enter your app's Identity Provider SSO URL"
                />
              </Grid>
              <Grid item style={{ width: '100%' }}>
                <Typography>Identity Provider Issuer</Typography>
                <TextField
                  name='SAMLIdentityProviderIssuer'
                  fullWidth
                  variant='outlined'
                  value={
                    this.state.SAMLIdentityProviderIssuer === ' '
                      ? ''
                      : this.state.SAMLIdentityProviderIssuer
                  }
                  onChange={this.handleSAMLInput}
                  style={{ padding: '10px 0 10px 0' }}
                  placeholder="Please enter your app's Identity Provider Issuer"
                />
              </Grid>
              <Grid item style={{ width: '100%' }}>
                <Typography>X.509 Certificate</Typography>
                <TextField
                  name='SAMLCertificate'
                  multiline
                  rows={5}
                  fullWidth
                  variant='outlined'
                  value={this.state.SAMLCertificate === ' ' ? '' : this.state.SAMLCertificate}
                  onChange={this.handleSAMLInput}
                  style={{ padding: '10px 0 10px 0' }}
                  placeholder="Please enter your app's X.509 Certificate"
                />
              </Grid>
              {!isSamsungPublisher(this.props.session.publisher.ID) && (
                <Grid
                  item
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                  }}
                >
                  <Typography>
                    Autoprovision Accounts
                    <Tooltip
                      title={
                        'When toggled on, "Autoprovision Account" automatically creates a user\'s account when navigating to Publica via their SAML provider if the user\'s account does not currently exist.'
                      }
                      placement='top'
                    >
                      <InfoIcon
                        style={{
                          verticalAlign: 'bottom',
                          width: '1rem',
                          color: '#929599',
                          marginLeft: '5px',
                        }}
                      />
                    </Tooltip>
                  </Typography>
                  <ModelSwitchView
                    checked={this.state.SAMLAutoprovision === EBool.EBool_TRUE}
                    model={this.state}
                    onChange={() => {
                      this.setState({
                        SAMLAutoprovision:
                          this.state.SAMLAutoprovision === EBool.EBool_TRUE
                            ? EBool.EBool_FALSE
                            : EBool.EBool_TRUE,
                      });
                    }}
                  />
                </Grid>
              )}
              {this.state.SAMLAutoprovision === EBool.EBool_TRUE && (
                <Grid
                  item
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                  }}
                >
                  <Typography>
                    New User Role
                    <Tooltip
                      title={
                        'Select the role for new users created when "Autoprovision Accounts" is toggled on.'
                      }
                      placement='top'
                    >
                      <InfoIcon
                        style={{
                          verticalAlign: 'bottom',
                          width: '1rem',
                          color: '#929599',
                          marginLeft: '5px',
                        }}
                      />
                    </Tooltip>
                  </Typography>
                  <Select
                    autoFocus
                    margin='dense'
                    id='SAMLPermissionsRoleID'
                    name='SAMLPermissionsRoleID'
                    label='role name'
                    type='text'
                    value={this.state.SAMLPermissionsRoleID ? this.state.SAMLPermissionsRoleID : 17}
                    onChange={this.handleSAMLInput}
                    style={{ width: '200px' }}
                  >
                    {(this.state.publisherPermissionsRoles || []).map((role: IRole) => {
                      return <MenuItem value={role.id}>{role.name}</MenuItem>;
                    })}
                  </Select>
                </Grid>
              )}
            </Grid>
          </Grid>
          <DialogActions>
            <AsyncButtonOldV2
              text='Update'
              onClick={this.handleAsyncButtonClick('updateSAMLIdentityProvider')}
            />
            <Button
              autoFocus
              color='secondary'
              onClick={() =>
                this.setState({ openSAMLIntegrationModal: SAMLIntegrationModal.CLOSE })
              }
            >
              Cancel
            </Button>
          </DialogActions>
        </DialogWidth720>
      );
    };

    renderDealDemandPartnerCreation = () => {
      const availablePartners = getHeaderBidderAdaptersForPublisher('', true).filter(
        (headerBidderAdapters) =>
          ![
            'dynamicGateway',
            'dynamicPlatformConnection',
            'gateway',
            'gatewayTier0',
            'platformConnection',
            'publica',
            'publicaCampaign',
          ].includes(headerBidderAdapters.key),
      );

      return (
        <DialogWidth480
          maxWidth='md'
          keepMounted
          open={this.state.openCreateDealDemandPartnerModal}
          onClose={this.handleCloseCreateDealDemandPartnerDialog}
        >
          <Row style={{ padding: '30px' }}>
            <Text large>Add Deal Demand Proposal Partner</Text>
            <Row style={{ width: '100%' }}>
              <TextField
                name='dealDemandPartnerName'
                label='Name'
                select
                fullWidth
                required
                onChange={this.handleChange}
                value={this.state.dealDemandPartnerName}
                style={{ padding: '10px 0 10px 0' }}
              >
                <MenuItem value=''>None</MenuItem>
                {availablePartners.map((hb: IHeaderBidderAdapter) => {
                  return (
                    <MenuItem key={'hb_' + hb.key} value={hb.key}>
                      {hb.text}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Row>
          </Row>
          <DialogActions>
            <AsyncButtonOldV2
              text='Confirm'
              onClick={this.handleAsyncButtonClick('createDealDemandPartner')}
            />
            <Button
              autoFocus
              color='secondary'
              onClick={this.handleCloseCreateDealDemandPartnerDialog}
            >
              Cancel
            </Button>
          </DialogActions>
        </DialogWidth480>
      );
    };

    render() {
      const { classes, user, session, location } = this.props;
      const { pathname } = location;
      const refreshAPITokenAuth = IS_AUTHORIZED(['write_api_token'], user.user).isAuthorized;

      const s3Form: IFormItem[] = [
        { id: 'BucketName', label: 'Bucket Name', render: FormItemTypeText, required: true },
        { id: 'Region', label: 'Region', render: FormItemTypeText, required: true },
        {
          id: 'FileDestination',
          label: 'File Destination',
          render: FormItemTypeText,
          required: true,
        },
        {
          id: 'AccessKey',
          label: 'Access Key (should start with "AKIA")',
          render: FormItemTypePassword,
          required: false,
        },
        { id: 'SecretKey', label: 'Secret Key', render: FormItemTypePassword, required: false },
      ];

      const localizationItems = this.state.localizations.map((localization: ILocalization) => {
        return {
          label: localization.Name,
          value: localization.ID,
        };
      });
      const localizationForm: IFormItem[] = [
        {
          id: 'Localization',
          label: 'Localization Type',
          render: FormItemTypeSingleSelect,
          required: true,
          props: { items: localizationItems },
        },
      ];
      const publisherAccessKeysForm: IFormItem[] = [
        { id: 'PublisherAccessKey', label: 'Access Key', render: FormItemTypeText },
        { id: 'PublisherSecretKey', label: 'Secret Key', render: FormItemTypeText },
      ];

      const PublicaVaultTTLs = [
        {
          label: '15 Minutes',
          id: 15,
        },
        {
          label: '30 Minutes',
          id: 30,
        },
        {
          label: '45 Minutes',
          id: 45,
        },
        {
          label: '1 Hour',
          id: 60,
        },
      ];

      const options = [
        {
          key: 'default',
          value: '0',
          label: '%',
          isSelected:
            this.state.DefaultPublicaVaultConfig.MaxUnderFloorType === MaxUnderFloorType.Percent,
          isDisabled: false,
        },
        {
          key: 'custom',
          value: '1',
          label: convertECurrencyTypeToSymbol(
            convertStringToECurrencyType(this.state.CurrencyDisplayed),
          ),
          isSelected:
            this.state.DefaultPublicaVaultConfig.MaxUnderFloorType !== MaxUnderFloorType.Percent,
          isDisabled: false,
        },
      ];

      const roleIsSuperOrReseller =
        hasRoleSuperUser(this.props.user.user) || hasRole(this.props.user.user, [ROLE_RESELLER]);
      const isResellerParentPub = this.isResellerParentPub(this.props.session.publisher.ID);
      return (
        <Panels maxWidth vertical relative minWidthMain>
          <Panel
            largeHorizontalPadding
            verticalPadding
            style={{ borderBottom: `1px solid ${publicaColors.lightGray}` }}
          >
            <ModelTopBar
              title={routeName(pathname)}
              session={session}
              user={user}
              publisher={session.publisher}
              classes={classes}
              delegateElevate={true}
              currentPath={pathname}
              disableTitlePaddingLeft
            />
          </Panel>
          <Panel scroll largePadding>
            <Paper
              classes={{
                root: classes.paper,
              }}
            >
              <Typography variant='h6' gutterBottom>
                Update Account
              </Typography>
              <RenderForm
                schema={this.getPublisherForm()}
                data={{
                  Name: checkUserInfoMasked(this.props.user.user)
                    ? 'Demo Account'
                    : this.state.Name,
                  Domain: checkUserInfoMasked(this.props.user.user)
                    ? 'demoaccount.com'
                    : this.state.Domain,
                  Timezone: this.state.Timezone,
                  RokuSeatID: this.state.RokuSeatID,
                  NetworkEnabled: EBool.toBoolString(this.state.NetworkEnabled),
                  NativeVastEnabled: EBool.toBoolString(this.state.NativeVastEnabled),
                  EnableIASDataSharing: EBool.toBoolString(this.state.EnableIASDataSharing),
                  IASDataSharing: this.state.IASDataSharing,
                  EnableDoubleVerifyDataSharing: EBool.toBoolString(
                    this.state.EnableDoubleVerifyDataSharing,
                  ),
                  DoubleVerifyDataSharing: this.state.DoubleVerifyDataSharing,
                  ExcludedReportingDimensions: this.state.ExcludedReportingDimensions,
                  CurrencyDisplayed: this.state.CurrencyDisplayed,
                  EnableOtherCurrency: this.state.EnableOtherCurrency,
                  EnableAPSDemand: this.state.EnableAPSDemand,
                  EnableBulkAPIs: this.state.EnableBulkAPIs,
                  EnablePublicaVault: this.state.EnablePublicaVault,
                  IsResellerPublisher: this.state.IsResellerPublisher,
                  PublisherDevelopmentManager: this.state.PublisherDevelopmentManager,
                  SupportTier: String(this.state.SupportTier),
                  SolutionsArchitect: this.state.SolutionsArchitect,
                  EnableIASFirstPartyVASTTracking: EBool.toBoolString(
                    this.state.EnableIASFirstPartyVASTTracking,
                  ),
                  IASAnID: this.state.IASAnID === 0 ? '' : this.state.IASAnID.toString(),
                  EnableIASThirdPartyVASTTracking: EBool.toBoolString(
                    this.state.EnableIASThirdPartyVASTTracking,
                  ),
                  IrisClientToken: this.state.IrisClientToken,
                  ContextualSegmentEnabled: EBool.toBoolString(this.state.ContextualSegmentEnabled),
                  ComscoreContextualSegmentsEnabled: EBool.toBoolString(
                    this.state.ComscoreContextualSegmentsEnabled,
                  ),
                  IrisContextualSegmentsEnabled: EBool.toBoolString(
                    this.state.IrisContextualSegmentsEnabled,
                  ),
                  IASContextualSegmentsEnabled: EBool.toBoolString(
                    this.state.IASContextualSegmentsEnabled,
                  ),
                  EnableExtendedRewrites: EBool.toBoolString(this.state.EnableExtendedRewrites),
                  EnablePlatformMarketplace: EBool.toBoolString(
                    this.state.EnablePlatformMarketplace,
                  ),
                  PublisherType: this.state.PublisherType.toString(),
                  LogSamplingEnabled: EBool.toBoolString(this.state.LogSamplingEnabled),
                  EnableAllCreativeScanForEleaAI: EBool.toBoolString(
                    this.state.EnableAllCreativeScanForEleaAI,
                  ),
                  OpenPathEnabled: EBool.toBoolString(this.state.OpenPathEnabled),
                  EnableGoogleAdxSSLCert: EBool.toBoolString(this.state.EnableGoogleAdxSSLCert),
                  SmartFloorsEnabled: EBool.toBoolString(this.state.SmartFloorsEnabled),
                  EnableCreativeQualityAssurance: EBool.toBoolString(
                    this.state.EnableCreativeQualityAssurance,
                  ),
                  EnableSponsorshipMode: this.state.EnableSponsorshipMode,
                  MRMEnrichmentMode: this.state.MRMEnrichmentMode,
                }}
                onUpdate={this.onUpdatePublisher}
                handleSnackbar={this.handleSnackbar}
              />
              {hasRoleSuperUser(this.props.user.user) && (
                <>
                  {this.renderAllowPublisherIrisAltContentID()}
                  {this.renderDDMonitoring()}
                  {this.renderPublisherLogSampling()}
                  {this.renderEnableOpenPath()}
                  {this.renderEnableGoogleSSL()}
                  {this.renderEnableSSAI()}
                  {this.renderEnableNativeVast()}
                  {this.renderSmartFloorsEnabled()}
                  {this.renderEnableOtherCurrency()}
                  {this.renderEnableAPSDemand()}
                  {EBool.isTrue(this.state.EnableAPSDemand) && this.renderEnableAPSDedup()}
                  {this.renderEnableBatchAPIs()}
                  {this.renderEnablePublicaVaultAPIs()}
                  {this.renderEnableSponsorshipMode()}
                  {this.renderIsResellerPublisher()}
                  {this.renderEnableMRMDataEnrichment()}
                  {this.renderManageFraudDetection()}
                </>
              )}

              {(hasRoleSuperUser(this.props.user.user) ||
                isPhiloPublisher(this.props.session.publisher.ID)) &&
                this.renderDisableCreativeBlocking()}

              <div style={{ marginTop: '2rem' }}>
                <AsyncButtonOldV2
                  text='Save'
                  onClick={this.handleAsyncButtonClick('updatePublisher')}
                />
              </div>
            </Paper>
            {hasRoleSuperUser(this.props.user.user) && this.renderEnableAdQualityTools()}
            {hasRoleSuperUser(this.props.user.user) && this.renderEnableTrafficShaping()}

            <Paper
              classes={{
                root: classes.paper,
              }}
            >
              <Typography variant='h6' gutterBottom>
                Bidder Tier Aliases
              </Typography>
              <RenderForm
                schema={bidderTierForm}
                data={{
                  BidderTier1CustomName: this.state.BidderTier1CustomName,
                  BidderTier2CustomName: this.state.BidderTier2CustomName,
                  BidderTier3CustomName: this.state.BidderTier3CustomName,
                  BidderTier4CustomName: this.state.BidderTier4CustomName,
                  BidderTier5CustomName: this.state.BidderTier5CustomName,
                  BidderTier6CustomName: this.state.BidderTier6CustomName,
                  BidderTier7CustomName: this.state.BidderTier7CustomName,
                  BidderTier8CustomName: this.state.BidderTier8CustomName,
                  BidderTier9CustomName: this.state.BidderTier9CustomName,
                  BidderTier10CustomName: this.state.BidderTier10CustomName,
                }}
                onUpdate={this.onUpdateBidderTier}
              />
              <div style={{ marginTop: '2rem' }}>
                <AsyncButtonOldV2
                  text='Save'
                  onClick={this.handleAsyncButtonClick('updateBidderTier')}
                />
              </div>
            </Paper>
            {roleIsSuperOrReseller && isResellerParentPub ? this.renderActivateResellers() : null}
            <Paper
              classes={{
                root: classes.paper,
              }}
            >
              <Typography variant='h6' gutterBottom>
                Update Localization
              </Typography>
              <RenderForm
                schema={localizationForm}
                data={{
                  Localization: this.state.localizationID,
                }}
                errors={transformErrors(this.state.errors || {})}
                onUpdate={this.onUpdateLocalization}
              />
              <div style={{ marginTop: '2rem' }}>
                <AsyncButtonOldV2
                  text='Save'
                  onClick={this.handleAsyncButtonClick('updateLocalization')}
                />
              </div>
            </Paper>

            {EBool.isTrue(this.state.EnablePublicaVault) && (
              <Paper
                classes={{
                  root: classes.paper,
                }}
              >
                <Typography variant='h6' gutterBottom>
                  Publica Vault Configurations
                </Typography>
                <Row smallVerticalPadding noHorizontalPadding>
                  <ModelSwitchView
                    checked={this.state.DefaultPublicaVaultConfig.EnableByDefault}
                    model={this.state}
                    onChange={(_, data) =>
                      this.onUpdateDefaultPublicaVaultConfig(data, 'EnableByDefault')
                    }
                  />
                  Enable Publica Vault by default
                </Row>
                <Typography>
                  Define default settings that will be applied to any new channels you create.
                </Typography>
                <Row smallVerticalPadding noHorizontalPadding>
                  <Text baseSize style={{ marginBottom: spacing.extraSmall }}>
                    Exclude selected demand sources
                  </Text>
                  <IndependentSelect
                    handleApplySelect={(data) =>
                      this.onUpdateDefaultPublicaVaultConfig(data, 'ExcludedDemandSources')
                    }
                    placeholder='Select Demand Sources'
                    listLabel='Demand Sources'
                    singularLabel='Demand Source'
                    options={genDemandSourcesOptions(
                      this.props.session.publisher,
                      [],
                      '',
                      hasRoleSuperUser(this.props.user.user),
                    )}
                    selectedOptionIDs={
                      this.state.DefaultPublicaVaultConfig.ExcludedDemandSources?.length > 0
                        ? new Set(
                            this.state.DefaultPublicaVaultConfig.ExcludedDemandSources.split(','),
                          )
                        : new Set([])
                    }
                    key='demandSource'
                    maxWidth={280}
                  />
                </Row>
                <Row smallVerticalPadding noHorizontalPadding>
                  <Text baseSize style={{ marginBottom: spacing.extraSmall }}>
                    Exclude selected bidders
                  </Text>
                  <IndependentSelect
                    handleApplySelect={(data) =>
                      this.onUpdateDefaultPublicaVaultConfig(data, 'ExcludedBidderIDs')
                    }
                    placeholder='Select Bidders'
                    listLabel='Bidders'
                    singularLabel='Bidder'
                    options={this.state.BiddersList}
                    selectedOptionIDs={
                      this.state.DefaultPublicaVaultConfig.ExcludedBidderIDs?.length > 0
                        ? new Set(this.state.DefaultPublicaVaultConfig.ExcludedBidderIDs.split(','))
                        : new Set([])
                    }
                    key='bidders'
                    maxWidth={280}
                  />
                </Row>
                <Row smallVerticalPadding noHorizontalPadding>
                  <Text baseSize style={{ marginBottom: spacing.extraSmall }}>
                    TTL
                  </Text>
                  <IndependentSelect
                    handleApplySelect={(data) =>
                      this.onUpdateDefaultPublicaVaultConfig(data, 'TTL')
                    }
                    placeholder='Select TTL'
                    listLabel='TTL'
                    singularLabel='TTL'
                    selectedLimit={1}
                    options={PublicaVaultTTLs}
                    selectedOptionIDs={new Set([this.state.DefaultPublicaVaultConfig.TTL || 60])}
                    key='ttl'
                    maxWidth={280}
                  />
                </Row>
                <Row smallVerticalPadding noHorizontalPadding>
                  <Cols style={{ alignItems: 'center' }}>
                    <Col>
                      <Text small>
                        Bids are delivered in environments that align with their original targeting
                        intent. Matching is based on Device ID, Channel ID, IP, Content Genre, and
                        Content Rating. Content ID and App Bundle are optional
                      </Text>
                    </Col>
                  </Cols>

                  <Cols
                    style={{ alignItems: 'center', marginTop: spacing.small }}
                    gap={spacing.large}
                  >
                    <Cols style={{ alignItems: 'center' }}>
                      <Col marginRight={spacing.extraSmall}>
                        <Checkbox
                          checked={this.state.DefaultPublicaVaultConfig.ContentId}
                          name='ContentId'
                          onChange={(data) =>
                            this.onUpdateDefaultPublicaVaultConfig(data, 'ContentId')
                          }
                          size='medium'
                          style={{ padding: '0 0 2px 0' }}
                        />
                      </Col>
                      <Col>
                        <Text baseSize>Content ID</Text>
                      </Col>
                    </Cols>

                    <Cols style={{ alignItems: 'center' }}>
                      <Col marginRight={spacing.extraSmall}>
                        <Checkbox
                          checked={this.state.DefaultPublicaVaultConfig.AppBundle}
                          name='AppBundle'
                          onChange={(data) =>
                            this.onUpdateDefaultPublicaVaultConfig(data, 'AppBundle')
                          }
                          size='medium'
                          style={{ padding: '0 0 2px 0' }}
                        />
                      </Col>
                      <Col>
                        <Text baseSize>App Bundle</Text>
                      </Col>
                    </Cols>
                  </Cols>
                </Row>
                <Row smallVerticalPadding noHorizontalPadding>
                  <ModelSwitchView
                    checked={this.state.DefaultPublicaVaultConfig.StoreBelowFloorBids}
                    model={this.state}
                    onChange={(_, data) =>
                      this.onUpdateDefaultPublicaVaultConfig(data, 'StoreBelowFloorBids')
                    }
                  />
                  Store Below-Floor Bids
                  <Tooltip
                    title='Extend Vault functionality to include bid responses rejected for being below your specified floor.'
                    placement='top'
                  >
                    <InfoIcon
                      style={{
                        verticalAlign: 'bottom',
                        width: '1rem',
                        color: '#929599',
                        marginLeft: '5px',
                        marginBottom: '8px',
                      }}
                    />
                  </Tooltip>
                </Row>
                {this.state.DefaultPublicaVaultConfig.StoreBelowFloorBids && (
                  <Row smallVerticalPadding noHorizontalPadding>
                    <Text small style={{ marginBottom: spacing.extraSmall }}>
                      Set the maximum amount below your floor price that allows a bid to qualify to
                      win in a subsequent auction.
                    </Text>
                    <Col>
                      <Cols wrap style={{ alignItems: 'center' }}>
                        <Col style={{ marginRight: spacing.base, marginTop: spacing.small }}>
                          <Cols gap={spacing.extraSmall} style={{ alignItems: 'center' }}>
                            <Col>
                              <Text small bold>
                                Unit
                              </Text>
                            </Col>
                            <Col>
                              <PillSwitcherV2
                                size='extraSmall'
                                options={options}
                                backgroundColor={publicaColors.whiteOrchid}
                                onChange={(data) => {
                                  const isPercent = data === '0';
                                  this.onUpdateDefaultPublicaVaultConfig(
                                    isPercent,
                                    'MaxUnderFloorType',
                                  );
                                }}
                              />
                            </Col>
                          </Cols>
                        </Col>

                        <Col style={{ marginTop: spacing.small }}>
                          <Cols gap={spacing.extraSmall} style={{ alignItems: 'center' }}>
                            <Col>
                              <Text small bold>
                                Value
                              </Text>
                            </Col>
                            <Col>
                              <TextInput
                                type='number'
                                min={0}
                                max={50}
                                initialValue={String(
                                  this.state.DefaultPublicaVaultConfig.MaxUnderFloorValue,
                                )}
                                width='5rem'
                                inputSize='small'
                                step={0.5}
                                handleOnChange={(data) =>
                                  this.onUpdateDefaultPublicaVaultConfig(data, 'MaxUnderFloorValue')
                                }
                                onBlur={(e) => {
                                  // Default value 20% if there's no input
                                  if (
                                    e.currentTarget.value === '' &&
                                    this.state.DefaultPublicaVaultConfig.MaxUnderFloorType ===
                                      MaxUnderFloorType.Percent
                                  ) {
                                    e.currentTarget.value = '20';
                                  }
                                }}
                              />
                            </Col>
                          </Cols>
                        </Col>
                      </Cols>
                    </Col>
                  </Row>
                )}
                <div style={{ marginTop: '2rem' }}>
                  <AsyncButtonOldV2
                    text='Save'
                    onClick={this.handleAsyncButtonClick('updateDefaultPublicaVaultConfig')}
                  />
                </div>
              </Paper>
            )}

            {EBool.isTrue(this.state.EnableIASIVTBlocklist) && (
              <Paper
                classes={{
                  root: classes.paper,
                }}
              >
                <Text subheader tKey='ManageFraudDetection' />
                <Text
                  small
                  style={{ marginBottom: spacing.small }}
                  tKey='SelectOneOfTheFollowingFeaturesFraudTraffic'
                />
                <Text small>
                  <Span
                    style={{ fontWeight: 'bold', marginRight: spacing.extraSmall }}
                    tKey='EnableForAllInventoryWithColon'
                  />
                  <Span tKey='AutomaticallyBlocksFraudAcrossAllOfYourInventory' />
                </Text>
                <Div smallVerticalPadding noHorizontalPadding>
                  <ModelSwitchView
                    checked={EBool.toBool(this.state.IASIVTBlocklistTargetingAllInventory)}
                    model={this.state}
                    onChange={(_, data) =>
                      this.setState({
                        IASIVTBlocklistTargetingAllInventory: data
                          ? EBool.EBool_TRUE
                          : EBool.EBool_FALSE,
                        IASIVTBlocklistTargetingHeaderbidder: data
                          ? EBool.EBool_FALSE
                          : this.state.IASIVTBlocklistTargetingHeaderbidder,
                      })
                    }
                  />
                  {ct('EnableFraudDetectionAcrossAllOfYourInventory')}
                </Div>
                <Text small>
                  <Span
                    style={{ fontWeight: 'bold', marginRight: spacing.extraSmall }}
                    tKey='ConfigurePerBidderWithColon'
                  />
                  <Span tKey='ManageFraudBlocking' />
                </Text>
                <Div smallVerticalPadding noHorizontalPadding>
                  <ModelSwitchView
                    checked={EBool.toBool(this.state.IASIVTBlocklistTargetingHeaderbidder)}
                    model={this.state}
                    onChange={(_, data) =>
                      this.setState({
                        IASIVTBlocklistTargetingHeaderbidder: data
                          ? EBool.EBool_TRUE
                          : EBool.EBool_FALSE,
                        IASIVTBlocklistTargetingAllInventory: data
                          ? EBool.EBool_FALSE
                          : this.state.IASIVTBlocklistTargetingAllInventory,
                      })
                    }
                  />
                  {ct('EnableFraudDetectionPerBidder')}
                </Div>
                {this.state.IASIVTBlocklistTargetingHeaderbidder === EBool.EBool_TRUE && (
                  <Div smallVerticalPadding noHorizontalPadding>
                    <Text baseSize style={{ marginBottom: spacing.extraSmall }}>
                      {ct('ApplySelectedItem', { item: 'Bidders' })}
                    </Text>
                    <IndependentSelect
                      handleApplySelect={(data) =>
                        this.onUpdateIASIVTBlocklistSelectedBidderIDs(data)
                      }
                      placeholder='Select Bidders'
                      listLabel='Bidders'
                      singularLabel='Bidder'
                      options={this.state.BiddersList}
                      selectedOptionIDs={
                        this.state.IASIVTBlocklistSelectedBidderIDs?.length > 0
                          ? new Set(this.state.IASIVTBlocklistSelectedBidderIDs.map(String))
                          : new Set([])
                      }
                      key='bidders'
                      maxWidth={280}
                    />
                  </Div>
                )}
                <Div style={{ marginTop: '2rem' }}>
                  <AsyncButtonOldV2
                    text={ct('Save')}
                    onClick={this.handleAsyncButtonClick('updateIASIVTBlocklist')}
                  />
                </Div>
              </Paper>
            )}

            <Paper
              classes={{
                root: classes.paper,
              }}
            >
              <Typography variant='h6' gutterBottom>
                Public API Token
              </Typography>
              <Typography
                noWrap={!this.state.showToken}
                style={{ wordBreak: 'break-word', marginBottom: 10 }}
              >
                {this.state.publisherAPIToken}
              </Typography>
              <Grid container justify='space-between'>
                <Grid item>
                  <CopyButton text='Copy To Clipboard' copy={this.state.publisherAPIToken} />
                </Grid>
                <Grid item>
                  <Button onClick={this.toggleShowToken}>Show Token</Button>
                </Grid>
                <Grid item>
                  <AsyncButtonOldV2
                    text='Regenerate'
                    onClick={this.handleAsyncButtonClick('updatePublisherAPIToken')}
                    disabled={!refreshAPITokenAuth}
                  />
                </Grid>
              </Grid>
            </Paper>

            <Paper
              classes={{
                root: classes.paper,
              }}
            >
              <Typography variant='h6' gutterBottom>
                Third Party Public API Tokens
              </Typography>
              {this.state.publisherThirdPartyAPITokens.length < 1 ? (
                <Typography>None</Typography>
              ) : (
                this.state.publisherThirdPartyAPITokens.map((token) => (
                  <Grid container style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                    <Grid item>
                      <Text bold>{token.Label}</Text>
                    </Grid>
                    <Grid item style={{ maxWidth: '300px' }}>
                      <Text
                        muted
                        style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {token.Token}
                      </Text>
                    </Grid>
                    <Grid item>
                      <CopyButton text='Copy' copy={token.Token} />
                    </Grid>
                  </Grid>
                ))
              )}
            </Paper>

            {isSamsungPublisher(this.props.user.publisher.ID) &&
            hasRoleSuperUser(this.props.user.user) ? (
              <Paper
                classes={{
                  root: classes.paper,
                }}
              >
                <Typography variant='h6' gutterBottom>
                  Publisher Access Keys
                </Typography>
                <RenderForm
                  schema={publisherAccessKeysForm}
                  data={{
                    PublisherAccessKey: this.state.publisherAccessKey,
                    PublisherSecretKey: this.state.publisherSecretKey,
                  }}
                  errors={transformErrors(this.state.errors || {})}
                  onUpdate={this.onUpdatePublisherAccessKeys}
                />
                <div style={{ marginTop: '2rem' }}>
                  <AsyncButtonOldV2
                    text='Save'
                    onClick={this.handleAsyncButtonClick('updatePublisherAccessKeys')}
                  />
                </div>
              </Paper>
            ) : (
              hasRoleAdmin(this.props.user.user) && (
                <Paper
                  classes={{
                    root: classes.paper,
                  }}
                >
                  <Typography variant='h6' gutterBottom>
                    Publisher Access Key
                  </Typography>
                  <Typography style={{ marginBottom: 10 }}>
                    {this.state.publisherAccessKey}
                  </Typography>
                  <Typography variant='h6' gutterBottom>
                    Publisher Secret Key
                  </Typography>
                  <Typography style={{ marginBottom: 10 }}>
                    {this.state.publisherSecretKey}
                  </Typography>
                </Paper>
              )
            )}
            {hasRoleSuperUser(this.props.user.user) &&
              this.state.OpenPathEnabled === EBool.EBool_TRUE && (
                <Paper
                  classes={{
                    root: classes.paper,
                  }}
                >
                  <Typography variant='h6' gutterBottom>
                    The Trade Desk S3 Access Point
                  </Typography>
                  <Typography>All fields must be provided</Typography>
                  <RenderForm
                    schema={s3Form}
                    data={{
                      BucketName: this.state.s3AccessPointTTD.BucketName,
                      Region: this.state.s3AccessPointTTD.Region,
                      FileDestination: this.state.s3AccessPointTTD.FileDestination,
                      AccessKey: this.state.s3AccessPointTTD.AccessKey,
                      SecretKey: this.state.s3AccessPointTTD.SecretKey,
                    }}
                    errors={transformErrors(this.state.errors || {})}
                    onUpdate={(formData) => this.onUpdateS3AccessPoint(formData, EBool.EBool_TRUE)}
                  />
                  <Grid container justifyContent='space-between'>
                    <Grid item>
                      <AsyncButtonOldV2
                        text='Save'
                        onClick={this.handleAsyncButtonClick('updateS3AccessPointTTD')}
                      />
                    </Grid>
                  </Grid>
                </Paper>
              )}
            <Paper
              classes={{
                root: classes.paper,
              }}
            >
              <Typography variant='h6' gutterBottom>
                General S3 Access Point
              </Typography>
              <Typography>All fields must be provided</Typography>
              <RenderForm
                schema={s3Form}
                data={{
                  BucketName: this.state.s3AccessPointGeneral.BucketName,
                  Region: this.state.s3AccessPointGeneral.Region,
                  FileDestination: this.state.s3AccessPointGeneral.FileDestination,
                  AccessKey: this.state.s3AccessPointGeneral.AccessKey,
                  SecretKey: this.state.s3AccessPointGeneral.SecretKey,
                }}
                errors={transformErrors(this.state.errors || {})}
                onUpdate={(formData) => this.onUpdateS3AccessPoint(formData, EBool.EBool_FALSE)}
              />
              <Grid container justifyContent='space-between'>
                <Grid item>
                  <AsyncButtonOldV2
                    text='Save'
                    onClick={this.handleAsyncButtonClick('updateS3AccessPointGeneral')}
                  />
                </Grid>
              </Grid>
            </Paper>
            {hasRoleSuperUser(this.props.user.user) ? this.renderFreeTrialControls() : null}
            {(hasRoleSuperUser(this.props.user.user) ||
              ([PID.tegna, PID.philo, PID.tMobile, PID.xumo].includes(
                this.props.user.publisher.ID,
              ) &&
                hasRoleAdmin(this.props.user.user))) && (
              // TODO: once this is open to general public, switch hasRoleSuperUser to
              // IS_AUTHORIZED(['admin'], this.props.user.user)
              <Paper
                classes={{
                  root: classes.paper,
                }}
              >
                <Typography variant='h6' gutterBottom>
                  Login Method
                </Typography>
                <Typography variant='subtitle2' color='textSecondary' gutterBottom>
                  Enable secure single sign-on
                </Typography>

                {this.renderLoginMethods()}

                <Grid item>
                  <AsyncButtonOldV2
                    text='Save'
                    onClick={this.handleAsyncButtonClick('updateLoginMethod')}
                  />
                </Grid>
              </Paper>
            )}
            {hasRoleSuperUser(this.props.user.user) && (
              <Paper
                classes={{
                  root: classes.paper,
                }}
              >
                <Typography variant='h6' gutterBottom>
                  Deal Proposal Partner Token *
                </Typography>
                <Typography variant='subtitle2' color='textSecondary' gutterBottom>
                  API Tokens for Demand Partners Using our Deal Proposal API
                </Typography>
                {this.renderDealDemandPartners()}
              </Paper>
            )}
            <SnackbarView
              open={!!this.state.snackbarMessage}
              error={!!this.state.snackbarError}
              onClose={this.snackbarClose}
              successBar={false}
              warning={!!this.state.snackbarWarning}
            >
              {this.state.snackbarMessage}
            </SnackbarView>
            <ModelDialogMultiActive
              active={this.state.modalActive}
              toActivateNames={this.state.toActivateModalNames}
              toDeactivateNames={this.state.toDeactivateModalNames}
              handleAccept={this.handleModalAcceptClick}
              handleCancel={this.handleModalCancelClick}
            />
            <ModalDialogCustomConfirmationView
              active={this.state.adQualityToolsModalActive}
              confirmationMessage={ct('AdQualityToolsConfirmation')}
              item={ct('PremiumFeatures')}
              onConfirm={() => {
                this.updateAdQualityTools();
              }}
              onCancel={() => {
                this.setState({ adQualityToolsModalActive: false });
              }}
            />
            {this.renderSAMLIntegration()}
            {this.renderDealDemandPartnerCreation()}

            {/* Deal Demand Partner delete dialog */}
            <ModelDialogDeleteView
              active={this.state.deleteDealDemandPartnerModalActive}
              model='Deal Demand Partner'
              ID={this.state.deleteDealDemandPartnerModalID}
              Name={this.state.deleteDealDemandPartnerModalName}
              disableSnackbar
              deleteModel={(id: string): Promise<any> => {
                return this.deleteDealDemandPartner(id);
              }}
              onDelete={this.handleCloseDeleteDealDemandPartnerDialog}
              onError={this.handleCloseDeleteDealDemandPartnerDialog}
              onClose={this.handleCloseDeleteDealDemandPartnerDialog}
            />

            {/* SAML Identity Provider delete dialog */}
            <ModelDialogDeleteView
              active={this.state.deleteSAMLModalActive}
              Name={this.state.deleteSAMLIdentityProvider.DisplayName}
              deleteModel={async () => {
                try {
                  await deleteSAMLIdentityProvider({
                    query: {
                      publisher_id: this.props.user.publisher.ID,
                      samlID: this.state.deleteSAMLIdentityProvider.ID,
                    },
                  });

                  // if the SAML Identity Provider being deleted is the one that's toggled on
                  // then we need to toggle Direct Login on instead.
                  const enabledSAMLIdentityProvider = this.state.SAMLIdentityProvidersList.filter(
                    (SAMLIdProvider) => {
                      return (
                        SAMLIdProvider.Enabled === EBool.EBool_TRUE &&
                        SAMLIdProvider.ID !== this.state.deleteSAMLIdentityProvider.ID
                      );
                    },
                  );
                  if (
                    enabledSAMLIdentityProvider.length === 0 &&
                    this.props.session.publisher.EnableDirectLogin === EBool.EBool_FALSE
                  ) {
                    updatePublisher({
                      query: {
                        publisher: {
                          ID: this.props.session.publisher.ID,
                          EnableDirectLogin: EBool.EBool_TRUE,
                        },
                      },
                    });
                  }
                  this.setState({
                    EnableDirectLogin: EBool.EBool_TRUE,
                    snackbarMessage: 'Successfully deleted the Login Method.',
                    snackbarError: false,
                    snackbarWarning: false,
                  });
                  this.getSAMLIdentityProvider();
                } catch (err) {
                  this.setState({
                    snackbarMessage: `${err}. Please try again later.`,
                    snackbarError: true,
                    snackbarWarning: false,
                  });
                }
              }}
              disableSnackbar
              onDelete={this.handleCloseSAMLDeleteModal}
              onError={this.handleCloseSAMLDeleteModal}
              onClose={this.handleCloseSAMLDeleteModal}
            />
          </Panel>
        </Panels>
      );
    }
  },
);
